//================================ Config fetch =================================
function debounce(func, wait) {
	const timeouts = {};
	return function (name, ...args) {
		if (timeouts[name]) {
			clearTimeout(timeouts[name]);
		}
		timeouts[name] = setTimeout(() => {
			delete timeouts[name];
			func.apply(this, [name, ...args]);
		}, wait);
	};
}
function createEvent(name, data = {}) {
	const event = new CustomEvent(name, {
		detail: data,
	});
	document.dispatchEvent(event);
}
const debouncedEvent = debounce(function (name, data) {
	createEvent(name, data);
}, 750);
(function () {
	if (window.__nubestFetchPatched) return;
	window.__nubestFetchPatched = true;
	const originalFetch = window.fetch.bind(window);
	function getFetchUrl(input) {
		if (typeof input === 'string') return input;
		if (input instanceof Request) return input.url;
		if (input && typeof input.url === 'string') return input.url;
		return '';
	}
	function parseBody(init) {
		const body = init && init.body;
		if (!body) return {};
		if (body instanceof FormData || body instanceof URLSearchParams) {
			return Object.fromEntries(body.entries());
		}
		if (typeof body === 'string') {
			try {
				return JSON.parse(body);
			} catch {
				return { raw: body };
			}
		}
		return {};
	}
	function safeEvent(name, payload) {
		try {
			if (typeof debouncedEvent === 'function') {
				debouncedEvent(name, payload);
			}
		} catch (err) {
			// console.warn('[nubest] debouncedEvent error:', err);
			throw err;
		}
	}
	function ensureCart() {
		window.Shopify = window.Shopify || {};
		Shopify.cart = Shopify.cart || { items: [] };
		Shopify.cart.items = Array.isArray(Shopify.cart.items) ? Shopify.cart.items : [];
	}
	async function safeJson(response) {
		try {
			return await response.clone().json();
		} catch {
			return null;
		}
	}
	window.fetch = async function (input, init) {
		const url = getFetchUrl(input);
		const body = parseBody(init);
		let response;
		try {
			response = await originalFetch(input, init);
		} catch (err) {
			console.warn('[nubest] fetch failed:', url, err);
			// throw err;
		}
		(async function handleFetchSideEffects() {
			try {
				if (!url) return;
				if (url.includes('/cart.js')) {
					const data = await safeJson(response);
					if (!data) return;
					window.Shopify = window.Shopify || {};
					Shopify.cart = data;
					safeEvent('cart_refresh', {
						u: url,
						data: data,
					});
					return;
				}
				if (url.includes('/add.js') || url.includes('/change.js')) {
					const data = await safeJson(response);
					if (!data || data.errors) return;
					let action = 'add';
					if (url.includes('/change.js')) {
						action = 'update';
						window.Shopify = window.Shopify || {};
						Shopify.cart = data;
					}
					if (url.includes('/add.js')) {
						ensureCart();
						const items = Array.isArray(data.items) ? data.items : [data];
						items.forEach(function (newItem) {
							if (!newItem || !newItem.key) return;
							const index = Shopify.cart.items.findIndex(function (item) {
								return item && item.key === newItem.key;
							});
							if (index !== -1) {
								Shopify.cart.items[index] = newItem;
							} else {
								Shopify.cart.items.push(newItem);
							}
						});
					}
					let queryParams = {};
					try {
						if (url.includes('?')) {
							queryParams = Object.fromEntries(new URLSearchParams(url.split('?')[1]));
						}
					} catch {
						queryParams = {};
					}
					const payload = {
						url: url,
						data: data,
						body: body,
						...queryParams,
					};
					safeEvent('cart_item_add_or_update', payload);
					safeEvent('cart_item_' + action, payload);
					return;
				}
				if (url.includes('a.klaviyo.com')) {
					safeEvent('klaviyo_load', {
						url: url,
						body: body,
					});
				}
			} catch (err) {
				console.warn('[nubest] fetch hook error:', err);
			}
		})();
		return response;
	};
})();
//================================ End Config fetch =================================
//================================ Function global =================================
function promiseFile(s1) {
	return new Promise((res, rej) => {
		s1.onload = function () {
			res();
		};
		s1.onerror = function () {
			rej();
		};
	});
}
function addCSS(src) {
	const el = document.createElement('link');
	el.rel = 'stylesheet';
	el.href = src;
	document.head.appendChild(el);
	return promiseFile(el);
}
function addScript(src) {
	const el = document.createElement('script');
	el.async = true;
	el.src = src;
	document.head.appendChild(el);
	return promiseFile(el);
}
function currencyWithRate(value) {
	return Shopify.currency.rate * value;
}
function formatCC(value, digit = 2) {
	if (T4SThemeSP.Currency) {
		let format = T4Sconfigs.moneyFormat;
		return T4SThemeSP.Currency.formatMoney(value, digit ? format : format.replace(/\{\{.*?\}\}/, '{{amount_no_decimals}}'));
	} else {
		value = value / 100;
		value = value
			.toLocaleString(Shopify.locale + '-' + Shopify.country, {
				style: 'currency',
				currency: Shopify.currency.active,
				maximumFractionDigits: digit,
			})
			.replace(/[^\d.,-]/g, '');
		return T4Sconfigs.moneyFormat.replace(/\{\{.*?\}\}/, value);
	}
}
function getCookie(name) {
	const value = `; ${document.cookie}`;
	const parts = value.split(`; ${name}=`);
	if (parts.length === 2) return parts.pop().split(';').shift();
}
function setCookie(name, value, days) {
	let expires = '';
	if (days) {
		const date = new Date();
		date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
		expires = '; expires=' + date.toUTCString();
	}
	document.cookie = name + '=' + (value || '') + expires + '; path=/';
}
function queryParam(param, value = false, state = false, url = '') {
	const obj = new URL(url ? url : window.location.href);
	if (value !== false) {
		if (value) {
			obj.searchParams.set(param, value);
		} else {
			obj.searchParams.delete(param);
		}
		if (state) {
			window.history.replaceState({}, '', obj);
		}
		return obj;
	} else {
		return obj.searchParams.get(param);
	}
}
async function geoLocation() {
	let geo = getCookie('geo');
	if (geo) {
		// console.log("Geo found in cookies:", JSON.parse(geo).country_code);
		try {
			return JSON.parse(geo);
		} catch {
			return {};
		}
	} else {
		try {
			const response = await fetch(window.Shopify.routes.root + 'browsing_context_suggestions.json');
			const data = await response.json();
			data.country_code = data.detected_values.country.handle;
			Shopify.geo_location = data.country_code;
			setCookie('geo', JSON.stringify(data), 7);
			// console.log("Geo fetched from API:", data.country_code);
			return data;
		} catch (error) {
			const defaultData = { country_code: 'US' };
			Shopify.geo_location = defaultData.country_code;
			// console.log('Error fetching geo, using default:', defaultData.country_code);
			return defaultData;
		}
	}
}
async function sleep(s) {
	await new Promise((r) => setTimeout(r, s * 1000));
}
//================================ End Function global =================================
//================================ Config MyAPI =================================
window.MyAPI = {
	config: {
		status: 1,
		progress: 0,
		set: function (k, v) {
			this[k] = v;
		},
	},
	client: {
		controllers: new Map(),
		call: function (url, options = {}) {
			const controller = new AbortController();
			url = url[0] == '/' ? url.substring(1) : url;
			options.signal = controller.signal;
			this.controllers.set(url, controller);
			const req = fetch(Shopify.routes.root + url, options)
				.then(async (r) => {
					let res;
					try {
						res = options.headers && options.headers['Content-Type'] === 'text/xml' ? await r.text() : await r.json();
					} catch {
						res = null;
					}
					return res;
				})
				.finally(() => this.controllers.delete(url));
			return req;
		},
		get: function (url, options = {}) {
			return this.call(url, options);
		},
		post: function (url, param = {}) {
			return this.call(url, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					'X-Requested-With': 'XMLHttpRequest',
				},
				body: JSON.stringify(param),
			});
		},
		abort: function (url) {
			const controller = this.controllers.get(url);
			if (controller) {
				controller.abort();
				this.controllers.delete(url);
				// console.log(`Request to ${url} was aborted.`);
			} else {
				// console.log(`No active request found for ${url}`);
			}
		},
	},
};
MyAPI.cart = {
	open: function (status = true) {
		if ($('#t4s-mini_cart').length > 0) {
			T4SThemeSP.Drawer.opend($('#t4s-mini_cart'));
		}
	},
	close: function (status = true) {
		$('[data-drawer-close]').trigger('click');
	},
	isLoading: function (status = true) {
		$('[data-cart-wrapper]').toggleClass('is--contentUpdate', status);
	},
	preLoad: function () {},
	setPreLoad: function (fn = () => {}) {
		this.preLoad = fn;
	},
	afterLoad: function () {},
	setAfterLoad: function (fn = () => {}) {
		this.afterLoad = fn;
	},
	call: function (r, fn) {
		this.preLoad();
		return r.then((res) => {
			fn(res);
			this.afterLoad();
		});
	},
	addItem: function (p, fn = (res) => {}) {
		if (typeof p === 'number') {
			p = { id: p };
		}
		if (!p.action) {
			p.action = 'add';
		}
		// console.log("addItem", p);
		MyAPI.config.set('status', 0);
		return this.call(MyAPI.client.post('cart/add.js?action=' + p.action, p), fn);
	},
	updateItem: function (p, fn = (res) => {}) {
		if (typeof p !== 'object') {
			p = { id: p, quantity: 1 };
		}
		if (!p.action) {
			p.action = 'update';
		}
		const cb = (res) => {
			fn(res);
			// this.getCart();
		};
		// console.log("updateItem", p);
		MyAPI.config.set('status', 0);
		return this.call(MyAPI.client.post('cart/change.js?action=' + p.action, p), cb);
	},
	deleteItem: function (p, fn = (res) => {}) {
		if (typeof p !== 'object') {
			p = { id: p };
		}
		p.quantity = 0;
		if (!p.action) {
			p.action = 'delete';
		}
		return this.updateItem(p, fn);
	},
	deleteItems: function (p, fn = (res) => {}) {
		if (p.length == 1) {
			return this.deleteItem(p[0], fn);
		}
		const updates = {};
		p.forEach((id) => {
			updates[id] = 0;
		});
		const cb = (res) => {
			fn(res);
			debouncedEvent('cart_item_add_or_update');
		};
		return this.updateCart({ updates }, cb);
	},
	getCart: function (fn = (res) => {}) {
		const cb = (res) => {
			fn(res);
			Shopify.cart = res;
		};
		return this.call(MyAPI.client.get('cart.js?r=' + new Date().getTime()), cb);
	},
	updateCart: function (u, fn = (res) => {}) {
		if (!u.action) {
			u.action = 'update_cart';
		}
		return this.call(MyAPI.client.post('cart/update.js?action=' + u.action, u), fn);
	},
	clearCart: function (fn = (res) => {}) {
		const cb = (res) => {
			fn(res);
			this.refreshCart();
		};
		return this.call(MyAPI.client.post('cart/clear.js'), cb);
	},
	applyCode: function (c, fn = (res) => {}) {
		let check = false;
		if (Shopify.cart) {
			check = JSON.stringify(Shopify.cart.items).indexOf(`"title":"${c}"`) !== -1;
			if (check) {
				return;
			}
		}
		const cb = (res) => {
			fn(res);
			// this.getCart();
			// this.refreshCart();
		};
		return this.call(
			MyAPI.client.get('discount/' + c, {
				headers: {
					'Content-Type': 'text/xml',
				},
			}),
			cb,
		);
	},
	refreshCart: () => {
		// if (!MyAPI.config.status) return;
		MyAPI.cart.isLoading(false);
		try {
			T4SThemeSP.Cart.getToFetch();
		} catch (e) {}
	},
};
MyAPI.product = {
	getProduct: function (h, fn = (res) => {}) {
		return MyAPI.client.get(`products/${h}.js`).then(fn);
	},
	getRecommendations: function (i, fn = (res) => {}) {
		if (typeof i !== 'object') {
			i = { product_id: i };
		}
		let url = 'recommendations/products';
		let options = {};
		if (i.section_id) {
			options.headers = {
				'Content-Type': 'text/xml',
			};
		} else {
			url += '.json';
		}
		i = new URLSearchParams(i).toString();
		return MyAPI.client.get(url + `?` + i, options).then(fn);
	},
};
MyAPI.search = {
	getSuggest: function (q, fn = (res) => {}) {
		if (typeof q !== 'object') {
			q = { q: q };
		}
		q = new URLSearchParams(q).toString();
		return MyAPI.client.get(`search/suggest.json?${q}`).then(fn);
	},
};
MyAPI.section = {
	getSection: function (i, fn = (res) => {}) {
		return MyAPI.client
			.get(i.indexOf('section_id') !== -1 ? i : `?section_id=${i}`, {
				headers: {
					'Content-Type': 'text/xml',
				},
			})
			.then(fn);
	},
	getSections: function (i, fn = (res) => {}) {
		return MyAPI.client.get(i.indexOf('sections') !== -1 ? i : `?sections=${i}`).then(fn);
	},
};
MyAPI.geo = {
	location: function (fn = (res) => {}) {
		return MyAPI.client.get(`browsing_context_suggestions.json`).then(fn);
	},
	ipgeo: function (fn = (res) => {}) {
		return MyAPI.client.get(`browsing_context_suggestions.json`).then(fn);
	},
};
//================================ End Config MyAPI =================================
//================================ Start Custom Menu Header =========================
$(document).ready(function () {
	let nb_menu_link_touch = false;
	var header_inline = $('#shopify-section-header-inline');
	var menu_nav = $('#t4s-nav-ul');
	menu_nav.on('hover', '.has--children', function (e) {
		if (window.innerWidth >= 1025) {
			if (!$(this).hasClass('is-action__hover')) {
				menu_nav.find('.is-action__hover').removeClass('is-action__hover');
			}
		}
		// $(this).addClass("is-action__hover");
	});
	menu_nav.on('touchstart', '.has--children', function (e) {
		if (!$(this).hasClass('is-action__hover')) {
			menu_nav.find('.is-action__hover').removeClass('is-action__hover');
			$(this).addClass('is-action__hover');
		} else {
			$(this).removeClass('is-action__hover');
		}
	});
	if (typeof screen.orientation != 'undefined') {
		screen.orientation.addEventListener('change', (event) => {
			header_inline.removeClass('open-menu').removeClass('open-menu-child');
			menu_nav.find('.btn-close-menu-child').remove();
			menu_nav.find('.active-menu-child').removeClass('active-menu-child');
			menu_nav.find('.is-action__hover').removeClass('is-action__hover');
		});
	}
	menu_nav.on('click', '.has--children', function (e) {
		if (window.innerWidth >= 1025) {
			$(this).toggleClass('is-action__hover');
		}
	});
	$(document).on('click', function (e) {
		if (window.innerWidth >= 1025) {
			if (!$(e.target).hasClass('.has--children') && $(e.target).closest('.has--children').length == 0) {
				menu_nav.find('.is-action__hover').removeClass('is-action__hover');
			}
		}
	});
	header_inline.on('click', '.nb-btn-menu-mb', function (e) {
		// console.log(e);
		nb_menu_link_touch = false;
		header_inline.toggleClass('open-menu');
		if (!header_inline.hasClass('open-menu')) {
			header_inline.removeClass('open-menu-child');
			header_inline.find('li').removeClass('active-menu-child');
			if (window.innerWidth < 1025) {
				header_inline.find('li').removeClass('is-action__hover');
			}
		}
		$('body').toggleClass('t4s-lock-scroll-menu');
	});
	menu_nav.on('touchstart', '.has--children .nb-menu-item-link', function (e) {
		e.preventDefault();
		nb_menu_link_touch = true;
		toggleMenuMobile(this);
	});
	menu_nav.on('click', '.has--children .nb-menu-item-link', function (e) {
		e.preventDefault();
		if (!nb_menu_link_touch) {
			toggleMenuMobile(this);
		}
	});
	function toggleMenuMobile(that) {
		let mn = $(that).closest('.t4s-menu-item');
		if ($(that).hasClass('btn-close-menu-child')) {
			header_inline.removeClass('open-menu-child');
			setTimeout(() => {
				mn.removeClass('active-menu-child');
			}, 400);
		} else {
			header_inline.addClass('open-menu-child');
			if (mn.find('.btn-close-menu-child').length == 0 && window.innerWidth < 1025) {
				let link = $(that).closest('a').clone();
				link.removeAttr('href').addClass('btn-close-menu-child');
				mn.find('.nb-mega-menu').prepend(link);
			}
			mn.addClass('active-menu-child');
		}
		nb_menu_link_touch = false;
	}
});
//================================ End Custom Menu Header =============================
MyAPI.cart.getCart();
function getDataPack(sku, qty = 1) {
	const r = { original: sku, sku: sku, pack: 1, quantity: 1 };
	if (!sku) {
		return r;
	}
	sku = sku.toString();
	const bgp = sku.match(/(.*)-B(\d+)G(\d+)-P(\d+)$/);
	const bg = sku.match(/(.*)-B(\d+)G(\d+)$/);
	const p = sku.match(/(.*)-P(\d+)$/);
	if (bgp) {
		r.sku = bgp[1];
		r.buy = parseInt(bgp[2]);
		r.get = parseInt(bgp[3]);
		r.pack = parseInt(bgp[4]);
	} else if (bg) {
		r.sku = bg[1];
		r.buy = parseInt(bg[2]);
		r.get = parseInt(bg[3]);
	} else if (p) {
		r.sku = p[1];
		r.pack = parseInt(p[2]);
	}
	r.quantity = qty * r.pack;
	return r;
}
function getRecommendationsCart(id = null) {
	let u = $('[data-cart-upsell-options]');
	if (u.length) {
		let d = u.data('cart-upsell-options');
		d.product_id = id ? id : $('[data-cart-items] [data-cart-item]:first').data('pid');
		MyAPI.product.getRecommendations(d, (r) => {
			u.html($(r).html());
			$('#t4s-mini_cart').toggleClass('recommendations_items_empty', $(r).find('.t4s-minicart-recommendations_items').length == 0);
			// let f = u.find(".flickityt4s")[0];
			// f.flickityt4s = new T4SThemeSP.Carousel(f);
		});
	}
}
//================================ Custom Cart Drawer =================================
function paramATC(that) {
	let id = $(that).data('id');
	let property = $(that).data('property');
	let selling_plan = $(that).data('selling_plan');
	let ids = id.toString().split('|');
	let p = {};
	let properties = {};
	if (property) {
		properties = property;
	}
	if (ids.length > 1) {
		p = { items: [] };
		for (let i = 0; i < ids.length; i++) {
			p.items.push({ id: ids[i], properties, selling_plan });
		}
	} else {
		p = { id, properties, selling_plan };
	}
	return p;
}
var $mini_cart = $('#t4s-mini_cart');
$(document).ready(function () {
	function cleanInvalidProperty() {
		if (!Shopify.cart || !Shopify.cart.items) return;
		const productIdsInCart = new Set(Shopify.cart.items.map((item) => item.product_id));
		let hasBundle = false;
		for (let index = 0; index < Shopify.cart.items.length; index++) {
			const item = Shopify.cart.items[index];
			const properties = item.properties || {};
			if (properties._nubest_bundle) {
				hasBundle = true;
			}
			const extraDiscount = properties._my_extra_discount;
			if (extraDiscount === 'Free Gift' && item.final_price > 0) {
				MyAPI.cart.deleteItem({ id: item.key });
			}
			const pairingProductId = properties._perfect_pairings_by;
			if (!pairingProductId) continue;
			if (!productIdsInCart.has(Number(pairingProductId))) {
				MyAPI.cart.updateItem({ line: index + 1, properties: { _my_boost_type: 'Checkout cart perfect pairings' } });
			}
		}
		if (hasBundle) {
			MyAPI.cart.clearCart();
		}
	}
	document.addEventListener('cart_refresh', function (event) {
		// console.log("cart_refresh", event);
		setTimeout(() => {
			cleanInvalidProperty(Shopify.cart);
		}, 500);
	});
	document.addEventListener('cart_item_add_or_update', async function (event) {
		// console.log('cart_item_add_or_update');
		cleanInvalidProperty(Shopify.cart);
		checkNBGift();
		checkBundle();
		let action = event.detail.action;
		let check = true;
		if (action) {
			if (action.indexOf('notier') !== -1) {
				return;
			}
			if (action.indexOf('noload') !== -1) {
				check = false;
			}
		}
		await load_cart_tier(check);
	});
	document.addEventListener('cart_item_add', function (event) {
		// console.log('cart_item_add');
		let detail = event.detail;
		checkTamixPopup(detail.body.tamix_popup, detail.data);
		checkShowVariantPopup(detail.data);
	});
	document.addEventListener('mini_cart_close', function (event) {
		// console.log('mini_cart_close');
	});
	document.addEventListener('mini_cart_open', function (event) {
		// console.log('mini_cart_open');
	});
	document.addEventListener('mini_cart_tier', function (event) {
		load_cart_tier();
	});
	$(document).on('click', '[data-quantity-selector1]', function (event) {
		let wrapper = $(this).closest('[data-quantity-wrapper]');
		let input = wrapper.find('[data-quantity-value]');
		let qty = input.val();
		if ($(this).data('decrease-qty') == '') {
			if (qty - 1 > 0) {
				--qty;
			}
		} else {
			++qty;
		}
		$(this).prop('disabled', qty == 1);
		actionLoading(this);
		MyAPI.cart.updateItem(
			{
				id: input.data('id'),
				quantity: qty,
			},
			(res) => {
				input.val(qty);
			},
		);
	});
	$(document).on('click', '.t4s-mini_cart-toggle', function (event) {
		debouncedEvent('mini_cart_open');
	});
	$(document).on('click', '.btn-sp-upgrade', function (event) {
		changeSellingPlan(this, this.dataset.sellingPlanId);
	});
	$(document).on('change', '.sp-list-opt', function (event) {
		// console.log("selling_plan_select change:", this.value);
		let $opt = $(this).closest('.sp-radio');
		if ($opt.length) {
			$(this).closest('form').find('input[name="selling_plan"]').val(this.value).trigger('change');
			$opt.find('[data-delivery-text]').text($(this).find('option:selected').text());
		} else {
			changeSellingPlan(this, this.value);
		}
	});
	$(document).on('click', '[data-add-to-cart]', function (event) {
		$(this).addClass('is--loading');
		$(this).find('.t4s-loading__spinner, .t4s-loading__spinner svg').removeAttr('hidden');
		MyAPI.cart.addItem(paramATC(this), (res) => {
			if (res.errors) return;
			setTimeout(() => {
				MyAPI.cart.open();
				$(this).removeClass('is--loading');
				$(this).find('.t4s-loading__spinner, .t4s-loading__spinner svg').attr('hidden', true);
			}, 1000);
			getRecommendationsCart(res.product_id ? res.product_id : res.items ? res.items[0].product_id : null);
		});
	});
	$(document).on('click', '[data-cart-remove1]', function (event) {
		event.preventDefault();
		actionLoading(this);
		let ids = $(this).data('id').split('|');
		MyAPI.cart.deleteItems(ids, (res) => {
			getRecommendationsCart();
		});
		return false;
	});
	if ($mini_cart.length) {
		$mini_cart.on('click', '.t4s-btn__shoppay', function (event) {
			$(this).prop('disabled', true);
			$mini_cart.find('[slot="button-ShopPay"]')[0].button.click();
		});
		$mini_cart.on('click', '.icon-cart-discount-remove', function (event) {
			MyAPI.cart.isLoading(true);
			MyAPI.cart.applyCode('clear');
		});
		$mini_cart.on('click', '.btn-addtocart-recommendation', function (event) {
			actionLoading(this);
			MyAPI.cart.addItem(paramATC(this), (res) => {
				getRecommendationsCart($('[data-cart-items] [data-cart-item]:first').data('pid'));
			});
		});
	}
	function checkTierGift(data) {
		let gift = data.gift_product;
		if (!gift || typeof gift !== 'object') {
			return;
		}
		let properties = { _mini_cart_gift: 'true', _my_boost_type: 'Tier Gift', _my_extra_discount: 'Free Gift ' + gift.id };
		let property = '_mini_cart_gift_' + gift.id;
		properties[property] = 'true';
		let status = [];
		let gift_item = null;
		let subtotal = 0;
		let skus = {};
		let chk_rule = 0;
		if (Shopify.cart.items) {
			for (let i = 0; i < Shopify.cart.items.length; i++) {
				let item = Shopify.cart.items[i];
				// let final_price = item.selling_plan_allocation ? item.selling_plan_allocation.compare_at_price : item.final_price;
				let final_price = item.final_price;
				subtotal += final_price * item.quantity;
				if (typeof item.properties != 'undefined') {
					if (typeof item.properties[property] != 'undefined') {
						gift_item = item;
					}
				}
				if (data.gift_rule && item.final_line_price) {
					if (data.gift_rule.indexOf(item.id.toString()) !== -1) {
						chk_rule = 1;
						let data_pack = getDataPack(item.sku, item.quantity);
						if (skus[data_pack.sku]) {
							skus[data_pack.sku] += data_pack.quantity;
						} else {
							skus[data_pack.sku] = data_pack.quantity;
						}
					}
				}
			}
		}
		if (data.gift_rule) {
			status.push(chk_rule);
			if (!chk_rule) {
				setTimeout(() => {
					$('#cart-tier').find(`[data-id="${gift.id}"]`).remove();
				}, 1000);
			}
		}
		let given = data.gift_quantity || 1;
		if (data.quantity) {
			given = 0;
			let mod = 0;
			let gift_pack = getDataPack(gift.sku);
			for (const [key, value] of Object.entries(skus)) {
				if (gift_pack.sku == key) {
					mod += data.quantity - (value % data.quantity);
					given += parseInt(value / data.quantity);
				}
			}
			data.quantity = mod;
			status.push(given > 0 ? 1 : 0);
		}
		if (data.country_code) {
			status.push(data.country_code == Shopify.country ? 1 : 0);
		}
		if (data.value) {
			status.push(subtotal >= currencyWithRate(data.value * 100) ? 1 : 0);
		}
		return {
			status: status.length == status.reduce((a, b) => a + b, 0),
			item: gift_item,
			data: {
				id: gift.id,
				quantity: given,
				properties: properties,
			},
		};
	}
	async function updateTierGifts(items, updates, deletes) {
		// console.log(items, updates, deletes);
		if (Object.keys(deletes).length) {
			await sleep(1);
			await MyAPI.cart.updateCart({
				action: 'noload',
				updates: deletes,
			});
		}
		if (Object.keys(updates).length) {
			await sleep(1);
			await MyAPI.cart.updateCart({ action: 'noload', updates });
		}
		if (items.length) {
			await sleep(1);
			await MyAPI.cart.addItem({ action: 'noload', items });
		}
	}
	function add_tier_item(data, check = true) {
		if (data.hidden) {
			return;
		}
		let img_default = `<svg class="t4s-icon t4s-icon--${data.type}" width="25" height="25"><use href="#icon-h-${data.type}"></use></svg>`;
		let img = img_default;
		let gift = data.gift_product;
		let gift_id = '';
		if (data.avatar) {
			img = `<img width="25" height="25" src="${data.avatar}&width=50">`;
		} else if (gift) {
			if (gift.image_url) {
				img = `<img width="25" height="25" src="${gift.image_url}&width=50">`;
			}
			gift_id = gift.id;
		}
		data.discount_code = data.discount_code ? data.discount_code : '';
		data.quantity = data.quantity ? data.quantity : '';
		data.gift_quantity = data.gift_quantity ? data.gift_quantity : '';
		if (data.type == 'shipping') {
			data.label = '<i class="tier-icon-check"></i> ' + data.label;
		}
		let el = `<div id="${data.id}" class="cart-tier-item item-${data.type}" data-code="${data.discount_code}" data-message="${data.message}" data-value="${data.value}" data-id="${gift_id}" data-quantity="${data.quantity}" data-given="${data.gift_quantity}"><div class="cart-tier-circle"><div class="cart-tier-icon">${img}</div></div><div class="cart-tier-description">${data.label}</div></div>`;
		if (data.gift_rule && Shopify.cart.items) {
			check = false;
			for (let i = 0; i < Shopify.cart.items.length; i++) {
				let item = Shopify.cart.items[i];
				if (item.final_line_price && data.gift_rule.indexOf(item.id.toString()) !== -1) {
					check = true;
				}
			}
		}
		if ($(`#cart-tier #${data.id}`).length || !check) {
			return;
		}
		return $(el);
	}
	if (location.pathname == '/pages/bfcm-exclusive-deals') {
		let now = new Date();
		let date = '2024-11-30 23:59:59';
		let end = new Date(date);
		if (now < end) {
			setCookie('bfcm', 'bfcm-' + end.getTime(), 29);
			MyAPI.cart.updateCart({
				attributes: {
					bfcm: date,
				},
			});
		}
	}
	async function load_cart_tier(reload = true) {
		await MyAPI.cart.getCart();
		let cart_tier = $('#cart-tier');
		let el = document.querySelector('.cart_tiers_json');
		let gift_datas = [];
		let gifts_id = [];
		let code = '';
		let $message = $('#t4s-mini_cart .t4s-cart-total-discount .mini_cart-message');
		$message.html('');
		if (el) {
			let tiers = null;
			try {
				tiers = JSON.parse(el.innerHTML);
			} catch {}
			if (tiers.length) {
				let $tier_items = $('#cart-tier .cart-tier-items');
				let time = getCookie('bfcm');
				for (let i = 0; i < tiers.length; i++) {
					let tier = tiers[i];
					if (tier.group == 'bfcm') {
						if (!time) {
							continue;
						} else {
							let time_ = time.split('-')[1];
							if (time_) {
								time = time_;
							}
							if (new Date(time).getTime() < new Date().getTime()) {
								setCookie('bfcm', '', 0);
								MyAPI.cart.updateCart({
									attributes: {
										bfcm: '',
									},
								});
								continue;
							}
						}
					}
					if (!code && tier.discount_code && tier.hidden) {
						code = tier.discount_code;
					}
					let $tier_item = add_tier_item(tier);
					if ($tier_item) {
						$tier_items.append($tier_item);
					}
					let obj = checkTierGift(tier);
					if (obj) {
						gift_datas.push(obj);
						if (gifts_id[obj.data.id]) {
							if (obj.status) {
								gifts_id[obj.data.id] = obj;
							}
						} else {
							gifts_id[obj.data.id] = obj;
						}
					}
				}
				let gifts_add = [];
				let gifts_update = {};
				let gifts_delete = {};
				for (let i in gifts_id) {
					let obj = gifts_id[i];
					if (obj.status) {
						if (obj.item) {
							if (obj.item.quantity != obj.data.quantity) {
								gifts_update[obj.item.key] = obj.data.quantity;
							}
						} else {
							gifts_add.push(obj.data);
						}
					} else if (obj.item) {
						gifts_delete[obj.item.key] = 0;
					}
				}
				await sleep(1);
				await updateTierGifts(gifts_add, gifts_update, gifts_delete);
			}
		}
		for (let i = 0; i < gift_datas.length; i++) {
			let obj = gift_datas[i];
			$('#cart-tier')
				.find(`[data-id="${obj.data.id.toString().split(':')[0]}"][data-given="${obj.data.quantity}"]`)
				.toggleClass('active', obj.status);
		}
		cart_tier.removeClass('tier-loading');
		let $content = cart_tier.find('.tier-message-content');
		if (!$content.length) {
			return;
		}
		let items = cart_tier.find('.cart-tier-item');
		let percent = 0;
		let remaining = 0;
		let step = 100 / items.length;
		let subtotal = 0;
		// let subtotal = Shopify.cart.items_subtotal_price / 100;
		let freeshipping = false;
		if (Shopify.cart && Shopify.cart.items) {
			subtotal =
				Shopify.cart.items
					.filter((l) => l.grams > 0 && l.requires_shipping)
					.reduce((total, item) => {
						return total + item.final_line_price;
					}, 0) / 100;
			for (let i = 0; i < Shopify.cart.items.length; i++) {
				let item = Shopify.cart.items[i];
				if (item.properties._my_extra_discount == 'Free Shipping') {
					freeshipping = true;
				}
			}
		}
		for (let i = 0; i < items.length; i++) {
			let $item = $(items[i]);
			let value = currencyWithRate($item.data('value') ? $item.data('value') : 0);
			let check = subtotal >= value;
			let id = $item.data('id');
			let quantity = $item.data('quantity');
			if ($item.hasClass('item-product')) {
				if ($item.hasClass('active')) {
					percent += step;
					continue;
				} else {
					check = false;
				}
			}
			if (freeshipping && $item.hasClass('item-shipping')) {
				check = true;
			}
			if (check) {
				$item.addClass('active');
				percent += step;
				if ($item.data('code')) {
					code = $item.data('code');
				}
			} else {
				$item.removeClass('active');
				if (remaining == 0 && value - subtotal > 0) {
					remaining = value - subtotal;
					let value_ = $(items[i - 1]).data('value');
					if (value_) {
						value -= value_;
					}
					percent += (1 - remaining / value) * step;
				}
			}
		}
		if (code) {
			setTimeout(() => {
				MyAPI.cart.applyCode(code, (res) => {
					debouncedEvent('mini_cart_tier');
				});
			}, 500);
		}
		let _content = '';
		if (items.length == cart_tier.find('.cart-tier-item.active').length) {
			let message_success = '<i class="tier-icon-check"></i> ' + $content.data('message-success');
			let shipping = cart_tier.find('.cart-tier-item.item-shipping.active');
			if (shipping.length) {
				message_success = message_success.replace('{{shipping}}', shipping.data('message'));
			}
			let discount = cart_tier.find('.cart-tier-item.item-discount.active');
			if (discount.length) {
				message_success = message_success.replace('{{discount}}', discount.data('message'));
			}
			let gifts = cart_tier.find('.cart-tier-item.item-product.active');
			if (gifts.length) {
				message_success = message_success.replace('{{product}}', gifts.length + ' Gift' + (gifts.length != 1 ? 's' : ''));
				// $message.html(`🎁 <span>You have earned a Free Gift<span>`);
			}
			_content = message_success;
			$content.addClass('cart-tier-message-success');
		} else {
			let message_remaining = $content.data('message-remaining').replace('{{remaining}}', formatCC(remaining * 100));
			let item_next = $(cart_tier.find('.cart-tier-item:not(.active)')[0]);
			if (item_next.hasClass('item-product')) {
				let qty = item_next.data('quantity');
				if (qty) {
					message_remaining = $content.data('message-remaining').replace('{{remaining}}', qty + ' bottle' + (qty != 1 ? 's' : ''));
				}
			}
			_content = message_remaining.replace('{{message}}', item_next.data('message'));
			$content.removeClass('cart-tier-message-success');
		}
		_content = _content.replaceAll(/{{[^}]*}}/g, '').replaceAll(/&  |  &/g, '');
		$content.html(_content);
		$content.css('opacity', 1);
		cart_tier.find('.cart-tier-bar-foreground').css('width', percent + '%');
		swapElement(cart_tier);
		if (reload) {
			MyAPI.cart.refreshCart();
		}
	}
	(function () {
		let callLimit = 0;

		const addonsInterval = setInterval(function () {
			if (++callLimit > 50) {
				return clearInterval(addonsInterval);
			}

			if (Shopify.cart && window.T4SThemeSP) {
				if ($mini_cart.length && !$mini_cart.find('.t4s-drawer__header').length) {
					return;
				}

				clearInterval(addonsInterval);
				debouncedEvent('mini_cart_tier');
			}
		}, 500);
	})();
	function swapElement(that) {
		let $items = $(that).find('.cart-tier-items');
		$items
			.find('.cart-tier-item')
			.sort((a, b) => ($(a).hasClass('active') ? 0 : 1) - ($(b).hasClass('active') ? 0 : 1) || ($(a).data('value') || 0) - ($(b).data('value') || 0))
			.appendTo($items);
	}
	function actionLoading(that) {
		MyAPI.cart.isLoading(true);
		let $this = $(that);
		$this.toggleClass('is--loading', true);
		let m = $this.closest('[data-cart-item]');
		m.toggleClass('is--update', true);
		// let p = m.find("a.t4s-pr [hidden]");
		// p.removeAttr("hidden");
		// let h = $this.parent("div:not([data-cart-item])").find("[hidden]");
		// h.removeAttr("hidden");
	}
	function changeSellingPlan(t, s) {
		actionLoading(t);
		let p = t.dataset;
		let c = $(t).closest('[data-cart-item]');
		let i = c.find('[data-quantity-value]');
		let q = i.val();
		let d = getDataPack(i.data('sku'), parseInt(q));
		let l = p.limit ? p.limit : 6;
		if (s && d.quantity > l) {
			l = parseInt(l) / d.pack;
			if (l >= 1) {
				q = Math.floor(l);
			} else {
				s = null;
			}
		}
		MyAPI.cart.updateItem({
			id: p.id,
			quantity: q,
			selling_plan: s,
		});
	}
	function checkBundle() {
		let $b = $('.bs-product-action');
		if ($b.length) {
			$b.prop('disabled', false);
			$b.find('.atc-name').text('Add');
			for (let i = 0; i < Shopify.cart.items.length; i++) {
				let $i = Shopify.cart.items[i];
				let $s = $(`.bs-product-action[data-id="${$i.id}"]`);
				if ($s.length) {
					$s.prop('disabled', true);
					$s.find('.atc-name').text('Added');
				}
			}
		}
	}
});
//================================ End Custom Cart Drawer =================================
//================================ Recharge Subscription =================================
$(document).ready(function () {
	function dataVariaints(that, option1 = null, option2 = null, option3 = null) {
		let variants;
		try {
			variants = JSON.parse($(that).closest('.t4s-product__info-container').find('.pr_variants_json').text());
		} catch {
			variants = [];
		}
		if (option1) {
			let datas = [];
			for (let index = 0; index < variants.length; index++) {
				let variant = variants[index];
				let check = option1 == variant.option1;
				if (option2) {
					check = check && option2 == variant.option2;
					if (option3) {
						check = check && option3 == variant.option3;
					}
				}
				if (check) {
					datas.push(variant);
				}
			}
			return datas;
		} else {
			return variants;
		}
	}
	function getDataVariant(that) {
		let variants = dataVariaints(that);
		let data = variants[0];
		let variant_id = null;
		let options = $(that).closest('.t4s-product__info-container').find('.t4s-swatch__list .is--selected[data-swatch-item]');
		for (let index = 0; index < variants.length; index++) {
			let variant = variants[index];
			if (variant_id) {
				if (variant_id == variant.id) {
					data = variant;
					break;
				}
			} else if (options.length) {
				let check = 0;
				for (let index2 = 0; index2 < options.length; index2++) {
					let option = options[index2];
					let option_value = variant['option' + option.dataset.index];
					if (option.dataset.value == option_value) {
						check++;
					}
				}
				if (check == options.length) {
					data = variant;
					break;
				}
			}
		}
		return data;
	}
	function changePriceATC(that, price, compare_price = '', variant = null) {
		let unit = 1;
		if (variant) {
			let parts = variant.sku.split('-');
			let part_last_p = parts[parts.length - 1].slice(0, 1);
			if (parts.length > 1 && part_last_p === 'P') {
				unit = parseInt(parts[parts.length - 1].replace('P', '')) || 1;
			}
		}
		let btn_price_block = $(that).closest('.t4s-product__info-container').find('[data-product-price2]');
		let btn_price = formatCC(price);
		let btn_compare_price = '';
		if (!compare_price) {
			compare_price = '';
		}
		if (compare_price) {
			btn_compare_price = formatCC(compare_price);
		}
		btn_price_block.html('<del>' + btn_compare_price + '</del>');
		btn_price_block.append('<ins>' + btn_price + '</ins>');
		let btn_unit_price_block = $(that).closest('.t4s-product__info-container').find('.tamix-product-unit-price').find('[data-product-price2]');
		let btn_unit_price = formatCC(price / unit);
		let btn_unit_compare_price = '';
		if (compare_price) {
			btn_unit_compare_price = formatCC(compare_price / unit);
		}
		btn_unit_price_block.html('<del>' + btn_unit_compare_price + '</del>');
		btn_unit_price_block.append('<ins>' + btn_unit_price + '</ins>');
		let isQS = $(that).closest('.t4s-product-quick-shop[data-product-featured]');
		if (isQS.length == 0) {
			let atc__price = $('.t4s-sticky-atc__product .t4s-sticky-atc__price');
			atc__price.html('<del>' + btn_unit_compare_price + '</del>');
			atc__price.append('<ins>' + btn_unit_price + '</ins>');
		}
	}
	function changePriceDiscount(that, price, compare_price = '') {
		let product__info = $(that).closest('.t4s-product__info-container');
		let option = product__info.find('.t4s-swatch__option:last-child');
		let option_index = option.find('[data-swatch-item]').data('index');
		if (option_index > 1) {
			let option_selected_value = product__info.find('.t4s-swatch__option:first-child .is--selected[data-swatch-item]').data('value');
			let variants = dataVariaints(that, option_selected_value);
			for (let index = 0; index < variants.length; index++) {
				let variant = variants[index];
				let save_discount = product__info.find('.t4s-swatch__option:last-child .t4s-swatch__item[data-value="' + variant['option' + option_index] + '"] .save .discount');
				if (save_discount.length) {
					save_discount.html(formatCC(variant.compare_at_price - variant.price));
				}
			}
		}
	}
	$(document).on('change', '.subscription-radio select', function (event) {
		// console.log("selling_plan_select change:", this.value);
		$(this).closest('form').find('input[name="selling_plan"]').val(this.value).trigger('change');
	});
	$(document).on('change', 'input.sp-radio__input', function (event) {
		$(this).closest('.nb-sp-widget').find('.sp-radio').removeClass('sp-radio--active');
		$(this).closest('.sp-radio').addClass('sp-radio--active');
	});
	$(document).on('change', 'input.selling_plan_option', function (event) {
		// console.log("selling_plan_option change:", this.value);
		let form = $(this).closest('form');
		let nb_sp_radios = $(this).closest('.nb-sp-widget').find('.sp-radio');
		let sp_radio = $(this).closest('.sp-radio');
		let purchase_type = $('.custom-purchase-type .selling-plan__purchase-type');
		let variant = getDataVariant(this);
		let price = variant.price;
		let compare_at_price = variant.compare_at_price;
		if (this.value == 'subscription') {
			$(this).closest('[data-product-featured]').find('.sp-list-opt').trigger('change');
			purchase_type.html('Subscription');
			price *= 1 - sp_radio.data('discount');
			if (!compare_at_price) {
				compare_at_price = variant.price;
			}
		} else {
			form.find('input[name="selling_plan"]').val('').trigger('change');
			purchase_type.html('One-time');
		}
		$.each(nb_sp_radios, function (i, el) {
			let price_label = $(el).find('.price-label');
			if (price_label.length) {
				let price_ = variant.price;
				if ($(el).hasClass('subscription-radio')) {
					price_ *= 1 - $(el).data('discount');
				}
				price_label.html(formatCC(price_));
			}
		});
		changePriceATC(this, price, compare_at_price, variant);
		if ($(this).data('option-index')) {
			$(this).data('option-index', '');
			$(this).data('option-value', '');
			changePriceDiscount(this, price, compare_at_price);
			let data_pack = getDataPack(variant.sku);
			// console.log("variant", data_pack);
			if (Shopify.cart) {
				for (let j = 0; j < Shopify.cart.items.length; j++) {
					let item = Shopify.cart.items[j];
					if (variant.id == item.variant_id) {
						data_pack = getDataPack(item.sku, item.quantity + 1);
						// console.log("cart", data_pack);
						break;
					}
				}
				let sum_qty = data_pack.quantity;
				let limit = 6;
				if (sum_qty > limit) {
					form.find('.onetime-radio input.selling_plan_option').prop('checked', true).trigger('change');
				}
				form.find('.nb-sp-widget').toggleClass('disabled', sum_qty > limit);
			}
		}
	});
	$(document).on('click', '.t4s-sticky-atc__product [data-dropdown-item]', function (event) {
		$('.is--selected[data-swatch-item]').trigger('click');
	});
	$(document).on('click', '[data-swatch-item]', function (event) {
		// console.log("variant change:", this.dataset.value);
		if (!$(this).hasClass('sns-swatch-item')) {
			let option = $(this).closest('.t4s-product-form__variants').parent().find('input.selling_plan_option:checked');
			if (option.length) {
				let save_discount = $(this).closest('.t4s-swatch__list').find('.save .discount');
				if (save_discount.length) {
					option.data('option-index', this.dataset.index);
					option.data('option-value', this.dataset.value);
				}
				option.trigger('change');
			} else {
				let variant = getDataVariant(this);
				let price = variant.price;
				let compare_at_price = variant.compare_at_price;
				if ($(this).hasClass('sp-price')) {
					let selling_plan = variant.selling_plan_allocations[0] || variant;
					price = selling_plan.price;
					compare_at_price = selling_plan.compare_at_price;
				}
				// console.log(compare_at_price, price);
				changePriceATC(this, price, compare_at_price, variant);
				changePriceDiscount(this, price, compare_at_price);
			}
		}
	});
	// =================================== Subscription and Save SnS =====================================
	$(document).on('change', 'input.sns-selling_plan_option', function (event) {
		// console.log("sns-selling_plan_option change:", this.value);
		let $f = $(this).closest('form');
		let $sp = $(this).closest('.sp-radio');
		let $q = $f.find('[name="quantity"]');
		let $id = $f.find('[name="id"]');
		let vid;
		if (this.value == 'subscription') {
			let spa_price = $sp.find('[data-spa-price]').data('spa-price');
			if (!spa_price) {
				$sp.find('.sns-swatch-item:first').trigger('click');
				return;
			}
			let price = formatCC(spa_price);
			let compare_at_price = formatCC($sp.find('[data-spa-compare_at_price]').data('spa-compare_at_price'));
			$sp.find('.t4s-product-price').html(`<ins>${price}</ins>`);
			if (compare_at_price && compare_at_price != price) {
				$sp.find('.price-label').html(`<del>${compare_at_price}</del> `);
			} else {
				$sp.find('.price-label').html('');
			}
			$sp.find('.price-label').append(`<ins>${price}</ins>`);
			$sp.find('select.sp-list-opt').trigger('change');
			$q.val(1);
			$q.data('qty', 1);
			vid = $f.find('.sns-swatch-item.is--selected').data('vid');
		} else {
			$q.val($q.data('qty'));
			$f.find('[name="selling_plan"]').val('');
			vid = $f.find('[name="id"] option:first').val();
			$sp.find('.one-time-quantity-select').trigger('change');
		}
		if (vid) $id.val(vid);
	});
	$(document).on('click', '.sns-swatch-item', function (event) {
		let $t = $(this);
		let $f = $t.closest('form');
		let $sp = $t.closest('.sp-radio');
		$sp.addClass('sns-loading');
		MyAPI.section.getSection($f.data('url') + '?section_id=sns_selling_plan&' + location.search, async (res) => {
			let plan = $(res).find(`[data-vid="${$t.data('vid')}"]`);
			$sp
				.find('.plan-setting')
				.html(plan)
				.promise()
				.done(function () {
					$f.find('.subscription-radio input.sns-selling_plan_option').prop('checked', true).trigger('change');
					let $ot = $t.closest('.sns-sp-widget').find('.one-time-quantity-select');
					if ($ot.find(`option[value="${$t.data('qty')}"]`).length) {
						$ot.val($t.data('qty')).trigger('change');
					}
					$sp.removeClass('sns-loading');
				});
		});
	});
	$(document).on('change', '.one-time-quantity-select', function (event) {
		let $f = $(this).closest('form');
		let $sub = $f.find('.subscription-radio input.sns-selling_plan_option:checked');
		let $sp = $(this).closest('.sp-radio');
		if (event.originalEvent) {
			$sp.addClass('sns-loading');
		}
		let opt = $(this).find(':selected');
		let price = opt.data('price');
		let discount = opt.data('discount');
		let type = opt.data('type');
		let value = this.value;
		let qty = $sub.length || type == 'variant' ? 1 : value;
		let html = formatCC(price);
		if (type == 'variant') {
			qty = 1;
			if (discount) {
				html = `<del>${formatCC(price + discount)}</del> ` + html;
			}
		}
		let vid;
		if ($sub.length) {
			vid = $f.find('.sns-swatch-item.is--selected').data('vid');
		} else if (type == 'variant') {
			vid = value;
		} else {
			vid = $f.find('[name="id"] option:first').val();
		}
		if (vid) $f.find('[name="id"]').val(vid);
		$f.find('[name="quantity"]').val(qty);
		$f.find('[name="quantity"]').data('qty', qty);
		$sp.find('.tamix-btn-price').html(html);
		$sp.find('.price-label').html(html);
		MyAPI.section.getSection($f.data('url') + '?section_id=sns_onetime_plan', async (res) => {
			let content = '';
			let plans = $(res).find('.plan-content');
			for (let index = 0; index < plans.length; index++) {
				let plan = plans[index];
				if (value <= $(plan).data('quantity')) {
					content = plan;
					//let $fs = $(plan).find('.tamix-sns-content');
					//$fs.toggleClass('sns-freeshipping', price / 100 >= $(this).data('freeshipping'));
					break;
				}
			}
			$sp.find('.plan-setting').html(content);
			$sp.removeClass('sns-loading');
		});
	});
	// =================================== End Subscription and Save =====================================
	$('input.sp-radio__input:checked').trigger('change');
	$(document).on('change', '[name="id"]', function (event) {
		let $form = $(this).closest('form');
		let $sl = $form.find('.sns-swatch-item.is--selected');
		if ($sl.length == 0) {
			$sl = $form.find('.sns-swatch-item:first');
		}
		// console.log('[name="id"] value ', this.value);
		// console.log('[name="id"] vid ', $sl.data("vid"));
		if (this.value && $sl.data('vid') && $sl.data('vid') != this.value) {
			$(this).val($sl.data('vid'));
		}
	});
});
//================================ End Recharge Subscription =================================
//================================ Marketing event cookie =================================
function tamix_checkCookieQuery(query) {
	let cookieValue = decodeURIComponent(getCookie('_shopify_sa_p'));
	if (!cookieValue) {
		return false;
	}
	const queries = query.split('&');
	for (let i = 0; i < queries.length; i++) {
		let [key, value] = queries[i].split('=');
		if (value) {
			if (value.endsWith('*')) {
				value = value.slice(0, -1);
				const regex = new RegExp(`${key}=${value}[a-zA-Z0-9_]*`);
				if (!regex.test(cookieValue)) {
					return false;
				}
			} else {
				const regex = new RegExp(`${key}=${value}(?![a-zA-Z0-9_])`);
				if (!regex.test(cookieValue)) {
					return false;
				}
			}
		} else {
			return false;
		}
	}
	return true;
}
function tamix_extractLinks() {
	let links = document.querySelectorAll('a.tamix-ecommerce-button');
	links.forEach(function (link) {
		let dataLink = link.getAttribute('data-link');
		if (dataLink) {
			let segments = dataLink.split(';tamix;');
			segments.forEach(function (segment) {
				let index = segment.indexOf('|');
				if (index !== -1) {
					let name = segment.substring(0, index);
					let url = segment.substring(index + 1);
					if (tamix_checkCookieQuery(name)) {
						link.href = url;
						// console.log(`Updated href to ${url} for link with id ${link.id}`);
					}
				}
			});
		}
	});
	document.querySelectorAll('.tamix-ecommerce-buttons-item').forEach(function (item) {
		const link = item.querySelector('a.tamix-ecommerce-button');
		if (link) {
			const href = link.getAttribute('href');
			if (href === '' || href === null || !href.trim()) {
				item.remove();
			}
		}
	});
}
tamix_extractLinks();
//================================ End Marketing event cookie =================================
//================================ Effect new-block-04 =================================
var tamix_linkbarMid = 0;
var tamix_heighttop = 0;
var tamix_firstTop = 0;
var tamix_lastTop = 0;
window.addEventListener('scroll', function () {
	let tamix_progressionElements = document.querySelectorAll('.item-progression');
	let tamix_linkbarElement = document.querySelector('.block-progression .link-bar');
	if (tamix_progressionElements.length > 0) {
		tamix_progressionElements.forEach(function (element) {
			if (element) {
				let elementPosition = element.getBoundingClientRect();
				let elementTop = elementPosition.top;
				let dotElement = element.querySelector('.tamix-grid .img .dot');
				if (dotElement) {
					let dotPosition = dotElement.getBoundingClientRect();
					let dotTop = dotPosition.top;
					let windowHeight = window.innerHeight;
					if (dotTop < windowHeight / 2) {
						element.classList.add('display');
					} else {
						element.classList.remove('display');
					}
					if (element.classList.contains('first')) {
						tamix_firstTop = dotTop;
						let tamix_heighttop = dotTop - elementTop + 15;
						tamix_linkbarElement.style.top = tamix_heighttop + 'px';
					}
					if (element.classList.contains('last')) {
						tamix_lastTop = dotTop;
						let heightbot = elementPosition.bottom - dotPosition.bottom + 15;
						let xxxx = elementTop - windowHeight / 2 + heightbot + tamix_heighttop;
						if (tamix_lastTop - 45 > windowHeight / 2) {
							tamix_linkbarMid = windowHeight / 2 - tamix_lastTop;
							tamix_linkbarElement.style.bottom = xxxx + 'px';
						} else {
							tamix_linkbarElement.style.bottom = heightbot + 'px';
						}
					}
				}
			}
		});
	}
});
//================================ End Effect new-block-04 =================================
//================================ Open cross domain to blank =================================
var links = document.links;
for (let i = 0, linksLength = links.length; i < linksLength; i++) {
	if (links[i].hostname !== window.location.hostname) {
		links[i].target = '_blank';
		let rel = links[i].rel;
		let rels = ['noopener', 'noreferrer'];
		for (let index = 0; index < rels.length; index++) {
			if (rel.indexOf(rels[index]) === -1) {
				rel += ' ' + rels[index];
			}
		}
		links[i].rel = rel;
	}
}
//================================ End Open cross domain to blank =================================
//================================ tamix-ecommerce-buttons-block =================================
function display_ecommerce_botton(elem4 = '') {
	(async () => {
		const data = await geoLocation();
		// console.log("Final geo data:", data.country_code);
		// const country = data.country_name;
		let buttons = [];
		if (elem4 != '') {
			buttons = elem4.querySelectorAll('.tamix-ecommerce-buttons-item');
		} else {
			buttons = document.querySelectorAll('.tamix-ecommerce-buttons-item');
		}
		let buttonAvaiable = 0;
		buttons.forEach(function (button) {
			let dataNation = button.getAttribute('data-nation');
			if (!dataNation || dataNation.includes(data.country_code)) {
				button.remove();
			} else {
				buttonAvaiable = buttonAvaiable + 1;
			}
		});
		if (buttonAvaiable > 0) {
			let addClass = 'flex-onlyone';
			if (buttonAvaiable >= 2 && buttonAvaiable % 2 == 1) {
				addClass = 'flex-odd';
			} else if (buttonAvaiable >= 2 && buttonAvaiable % 2 == 0) {
				addClass = 'flex-even';
			}
			if (elem4 != '') {
				buttons = elem4.querySelectorAll('.tamix-ecommerce-buttons-item');
			} else {
				buttons = document.querySelectorAll('.tamix-ecommerce-buttons-item');
			}
			buttons.forEach(function (button) {
				button.classList.add(addClass);
				button.classList.add('display_on');
				let dataReplace = button.getAttribute('data-replace_addtocart_button_block');
				//console.log("dataReplace");
				//console.log(dataReplace);
				// console.log(button);
				if (dataReplace == 'true') {
					document.querySelectorAll('.replace_addtocart_button_block').forEach((element) => {
						if (!element.classList.contains('display_off')) {
							element.classList.add('display_off');
						}
					});
					if (elem4 == '') {
						var style = document.createElement('style');
						style.innerHTML = `.t4s-sticky-atc .t4s-sticky-atc__btns .t4s-sticky-atc__atc{display:none !important}.t4s-sticky-atc .t4s-sticky-atc__btns .tamix-ecommerce-buttons-block{display:block !important;width:100%}.t4s-sticky-atc .t4s-sticky-atc__btns .tamix-ecommerce-buttons-block .tamix-ecommerce-buttons{margin-bottom:15px}`;
						document.head.appendChild(style);
					}
				}
			});
			// console.log('buttonAvaiable');
			// console.log(buttonAvaiable);
			if (buttonAvaiable > 1) {
				let el;
				if (elem4 != '') {
					el = elem4.querySelector('.tamix-ecommerce-buttons-title');
				} else {
					el = document.querySelector('.tamix-ecommerce-buttons-title');
				}
				if (el) {
					el.classList.add('display_on');
				}
			} else {
				if (elem4 != '') {
					elem4.querySelector('.tamix-ecommerce-button .buyon').classList.add('display_on');
				} else {
					document.querySelector('.tamix-ecommerce-button .buyon').classList.add('display_on');
				}
			}
		}
	})();
}
if (document.querySelector('.tamix-ecommerce-buttons-item')) {
	// console.log("call first");
	display_ecommerce_botton();
} else {
	geoLocation();
}
//================================ End tamix-ecommerce-buttons-block =================================
async function copyTextToClipboard(text, success = null, error = null) {
	try {
		await navigator.clipboard.writeText(text);
		if (success) success();
	} catch (err) {
		console.error('Copy failed:', err);
		if (error) error();
	}
}
function addNotifeedItems(node, items = []) {
	if (!node || !node.hasAttribute('data-atomato-notifeeds-host')) return;
	if (!items.length || !node.shadowRoot) return;
	const countEl = document.querySelector('[data-notifeed-bell-count]');
	const inner = node.shadowRoot.querySelector('div#atomato-app div[data-notifeed-list-inner]');
	if (!countEl || !inner) return;
	const list = inner.querySelector('ul[data-notifeed-list]');
	if (!list) return;
	const copyText = (el) => {
		const content = el.closest('[data-notifeed-content]');
		const title = content && content.querySelector('[data-notifeed-title]');
		if (!title) return;
		copyTextToClipboard(title.textContent, () => {
			el.textContent = 'Copied';
			setTimeout(() => (el.textContent = 'Copy'), 1500);
		});
	};
	list.querySelectorAll('[data-notifeed-button][aria-label="Copy"]').forEach((btn) => {
		btn.addEventListener('click', (e) => {
			e.preventDefault();
			copyText(btn);
		});
	});
	const template = list.querySelector('li');
	if (!template) return;
	const existingTitles = new Set([...list.querySelectorAll('[data-notifeed-title]')].map((el) => el.textContent.trim()));
	const uniqueItems = items.filter((item) => {
		const code = item.code;
		if (!code || existingTitles.has(code)) return false;
		existingTitles.add(code);
		return true;
	});
	if (!uniqueItems.length) return;
	countEl.textContent = (parseInt(countEl.textContent, 10) || 0) + uniqueItems.length;
	const fragment = document.createDocumentFragment();
	const itemHeight = template.offsetHeight || 0;
	uniqueItems.forEach((item) => {
		const clone = template.cloneNode(true);
		const btn = clone.querySelector('[data-notifeed-button]');
		const media = clone.querySelector('[data-notifeed-media]');
		const title = clone.querySelector('[data-notifeed-title]');
		const desc = clone.querySelector('[data-notifeed-description]');
		if (!btn || !title || !desc) return;
		clone.setAttribute('is-new', '');
		title.textContent = item.title || item.code;
		desc.textContent = item.description || 'Use your discount code at checkout.';
		btn.textContent = item.code ? 'Copy' : 'View';
		btn.setAttribute('aria-label', item.code ? 'Copy discount code' : 'View');
		if (item.code) {
			btn.removeAttribute('href');
			btn.addEventListener('click', (e) => {
				e.preventDefault();
				copyText(btn);
			});
		} else if (item.url) {
			btn.setAttribute('href', item.url);
		}
		if (media) {
			media.innerHTML = `<img src="${item.src || '//cdn.shopify.com/s/files/1/0799/8432/8989/files/discount-code.png?v=1780626609&width=240&height=240&crop=center'}" width="80" height="80" draggable="false">`;
		}
		fragment.appendChild(clone);
	});
	list.insertBefore(fragment, template);
	const currentHeight = parseInt(getComputedStyle(inner).getPropertyValue('--noti-height'), 10) || 0;
	inner.style.setProperty('--noti-height', `${currentHeight + itemHeight * uniqueItems.length}px`);
}
//================================ MutationObserver =================================
var observer2 = new MutationObserver((mutations) => {
	for (var mutation of mutations) {
		for (var node of mutation.addedNodes) {
			if (!(node instanceof HTMLElement)) continue;
			// Load dynamic checkout content
			if (!node.classList.length) {
				if (node.getAttribute('slot') == 'button-ShopPay') {
					// console.log(node);
					$('.t4s-btn__shoppay').prop('disabled', false);
				}
			}
			// load tamix-ecommerce-buttons-block
			for (var elem4 of node.querySelectorAll('.tamix-ecommerce-buttons-block')) {
				// console.log("observer elem4");
				display_ecommerce_botton(elem4);
			}
			addNotifeedItems(node, [{ code: getCookie('discount_code')?getCookie('discount_code').toUpperCase():null }]);
		}
	}
});
observer2.observe(document.getElementById('tamix-body'), {
	childList: true,
	subtree: true,
});
//================================ End MutationObserver =================================
//================================ Slider =================================
if (typeof Swiper == 'function') {
	let swiper = new Swiper('.swiper-container.two', {
		effect: 'coverflow',
		loop: true,
		centeredSlides: true,
		slidesPerView: 2,
		slideToClickedSlide: true,
		observer: true,
		observeParents: true,
		parallax: true,
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		coverflow: {
			rotate: 0,
			stretch: -300,
			depth: 250,
			modifier: 1.5,
			slideShadows: false,
		},
	});
}
$(document).ready(function () {
	$('.PDP-newOddit-Block05-Carousel').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
		let num = nextSlide + 1;
		$('.PDPnewOdditBlock05-nav-item').removeClass('active');
		$('.PDPnewOdditBlock05-nav-item-' + num).addClass('active');
		var scrollableElement = document.getElementById('block-nav');
		// console.log((num - 1) * 135);
		scrollableElement.scrollBy((nextSlide - 1) * 135, 0);
	});
	$('.PDP-newOddit-Block05-Carousel').slick({
		infinite: true,
		slidesToShow: 3,
		slidesToScroll: 1,
		arrows: false,
		dots: false,
		responsive: [
			{
				breakpoint: 1025,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1,
					infinite: true,
					dots: true,
				},
			},
			{
				breakpoint: 767,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					dots: true,
				},
			},
		],
	});
	$('.HGS-Facts-slider').slick({
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		dots: false,
	});
	var HGSmaxHeight = 0;
	$('.HGS-Facts-slider .column-grid-item').each(function () {
		var HGSthisHeight = $(this).outerHeight();
		if (HGSthisHeight > HGSmaxHeight) {
			HGSmaxHeight = HGSthisHeight;
		}
	});
	$('.HGS-Facts-slider .column-grid-item').css('height', HGSmaxHeight + 'px');
	$('a[href="#disable"]').on('touchstart click', function (event) {
		event.preventDefault();
	});
	$('.slider-blog').slick({
		dots: false,
		infinite: true,
		speed: 500,
		slidesToShow: 3,
		slidesToScroll: 1,
		autoplay: true,
		autoplaySpeed: 3000,
		arrows: false,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1,
					infinite: true,
					dots: true,
				},
			},
			{
				breakpoint: 600,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1,
					dots: true,
				},
			},
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					dots: true,
				},
			},
		],
	});
	$('.slider-inside').slick({
		autoplay: true,
		infinite: true,
		slidesToShow: 3,
		slidesToScroll: 1,
		dots: false,
		arrows: false,
		responsive: [
			{
				breakpoint: 1000,
				settings: {
					arrows: false,
					dots: true,
					slidesToShow: 2,
					slidesToScroll: 1,
					autoplay: true,
				},
			},
			{
				breakpoint: 767,
				settings: {
					arrows: false,
					dots: true,
					slidesToShow: 1,
					slidesToScroll: 1,
					autoplay: true,
				},
			},
		],
	});
});
//================================ End Slider =================================
//================================ Snippet tamix-video =================================
function playVideo(id_video) {
	let tamix_video_button = event.target;
	let tamix_video_videoContainer = tamix_video_button.closest('.video-container');
	let tamix_video_imgContainer = tamix_video_videoContainer.querySelector('.img');
	let tamix_video_iframeContainer = tamix_video_videoContainer.querySelector('.ifm');
	let tamix_video_blockIframeContainer = tamix_video_videoContainer.querySelector('.t4s-section-inner');
	let tamix_video_iframe = document.createElement('iframe');
	tamix_video_iframe.setAttribute('src', 'https://www.youtube.com/embed/' + id_video + '?controls=1&autoplay=1&showinfo=0&rel=0&modestbranding=1');
	tamix_video_iframe.setAttribute('class', 'frm');
	tamix_video_iframeContainer.appendChild(tamix_video_iframe);
	tamix_video_imgContainer.style.display = 'none';
	tamix_video_button.style.display = 'none';
	tamix_video_blockIframeContainer.style.display = 'block';
}
//================================ End Snippet tamix-video =================================
//================================ Snippet product-form =================================
function variant_more_options() {
	let tamix_target = event.target;
	let tamix_container = tamix_target.closest('.t4s-swatch__list');
	let tamix_block_button = tamix_container.querySelector('.block-btn');
	let tamixGridElements = tamix_container.querySelectorAll('.t4s-swatch__item');
	tamixGridElements.forEach((tamixGridElement) => {
		tamixGridElement.classList.remove('is__hidden');
	});
	tamix_block_button.style.display = 'none';
}
//================================ End Snippet product-form =================================
//================================ Snippet tamix-faqs =================================
function showcontent() {
	let tamix_faqs_target = event.target.closest('.question');
	if (!tamix_faqs_target) return;
	let tamix_faqs_container = tamix_faqs_target.closest('.item');
	let tamix_faqs_group = tamix_faqs_container.closest('.group_onlyone_faqs');
	let tamix_faqs_answer = tamix_faqs_container.querySelector('.answer');
	let tamix_faqs_icon = tamix_faqs_container.querySelector('.fas');
	if (!tamix_faqs_answer) return;
	let isActive = tamix_faqs_target.classList.contains('active');
	if (tamix_faqs_group) {
		tamix_faqs_group.querySelectorAll('.item').forEach((item) => {
			if (item !== tamix_faqs_container) {
				item.querySelector('.question').classList.remove('active');
				item.querySelector('.answer').classList.remove('show');
				let icon = item.querySelector('.fas');
				if (icon) {
					icon.classList.add('fa-plus');
					icon.classList.remove('fa-minus');
				}
			}
		});
	}
	const tamix_faqs_wrapper = tamix_faqs_target.closest('.newOddit-faqs-show-only-one');
	if (tamix_faqs_wrapper) {
		tamix_faqs_wrapper.querySelectorAll('.question.active').forEach((el) => {
			if (el !== tamix_faqs_target) {
				el.classList.remove('active');
			}
		});
		tamix_faqs_wrapper.querySelectorAll('.answer.show').forEach((el) => {
			if (el !== tamix_faqs_answer) {
				el.classList.remove('show');
			}
		});
		tamix_faqs_wrapper.querySelectorAll('.fa-minus').forEach((icon) => {
			// bỏ qua icon nằm trong question đang được click
			if (!tamix_faqs_target.contains(icon)) {
				icon.classList.remove('fa-minus');
				icon.classList.add('fa-plus');
			}
		});
	}
	tamix_faqs_target.classList.toggle('active');
	tamix_faqs_answer.classList.toggle('show');
	if (tamix_faqs_icon) {
		tamix_faqs_icon.classList.toggle('fa-minus');
		tamix_faqs_icon.classList.toggle('fa-plus');
	}
	setTimeout(() => {
		let rect = tamix_faqs_target.getBoundingClientRect();
		let viewportHeight = window.innerHeight;
		if (rect.top < 0 || rect.bottom > viewportHeight) {
			let scrollOffset = window.scrollY + rect.top - 200;
			window.scrollTo({ top: scrollOffset, behavior: 'smooth' });
		}
	}, 300);
}
function tamix_showmore() {
	let tamix_faqs_target = event.target.closest('.tamix_showmore');
	if (!tamix_faqs_target) return;
	tamix_faqs_target.classList.toggle('show');
}
function loadmoreFAQS(cls = 'BaseFAQs', length, limit = 6) {
	let tamix_faqs_target = event.target;
	let tamix_faqs_container = tamix_faqs_target.closest('.' + cls);
	let hiddenElements = tamix_faqs_container.querySelectorAll('.tamix-hidden');
	for (var i = 0; i < limit && i < hiddenElements.length; i++) {
		hiddenElements[i].classList.remove('tamix-hidden');
	}
	let hiddenElements2 = tamix_faqs_container.querySelectorAll('.tamix-hidden');
	if (hiddenElements2.length == 0) {
		tamix_faqs_target.classList.add('tamix-hidden');
	}
}
//================================ End Snippet tamix-faqs =================================
//================================ Loadmore Ingredients =================================
function loadmoreIngredient() {
	let tamix_target = event.target;
	let tamix_block_07 = tamix_target.closest('.Product-Detail-New-Block-07-Howitsmade');
	let tamix_block_button = tamix_block_07.querySelector('.block-btn');
	let tamixGridElements = tamix_block_07.querySelectorAll('.tamix-grid');
	tamixGridElements.forEach((tamixGridElement) => {
		tamixGridElement.classList.remove('hidden');
	});
	tamix_block_button.style.display = 'none';
}
//================================ End Loadmore Ingredients =================================
// Pages Refer A Friend - FAQs =========================================================
document.addEventListener('DOMContentLoaded', (event) => {
	var linkElement = document.querySelector('.here-yotpo-input');
	if (linkElement) {
		linkElement.addEventListener('click', function (event) {
			event.preventDefault();
			var inputElement = document.querySelector('.yotpo-input');
			if (inputElement) {
				inputElement.focus();
			} else {
				console.error('Input element not found.');
			}
		});
	}
});
//================================ End Pages Refer A Friend - FAQs =================================
//================================ ScrollTo target =================================
document.addEventListener('DOMContentLoaded', (event) => {
	$(document).on('click', 'a[href^="#"].tamixScrollTo', function (event) {
		var target = $($(this).attr('href'));
		if (target.length) {
			event.preventDefault();
			$('html, body').animate({ scrollTop: target.offset().top }, 1000);
		}
	});
});
//================================ End ScrollTo target =================================
//================================ TOC article =================================
document.addEventListener('DOMContentLoaded', function () {
	let $toc_contain = document.querySelector('.nb-toc-container');
	if ($toc_contain) {
		const content = document.querySelector('.t4s-main-article-page .t4s-article-content');
		$(document).on('click', 'a[href^="#"].nb-toc-item-link', function (event) {
			event.preventDefault();
			let $toc = $('#nb-toc-article');
			if (window.innerWidth < 1024) {
				$toc.removeClass('active');
			}
			let viewportTop = $(window).scrollTop();
			let viewportBottom = viewportTop + $(window).height();
			let el = $($(this).attr('href'));
			let rect = el.offset();
			let top = rect.top;
			let bottom = top + el.outerHeight();
			if (bottom < viewportTop) {
				top -= $('#shopify-section-header-inline').outerHeight();
				// top -= $toc.outerHeight();
			}
			$('html, body').animate({ scrollTop: top - 15 }, 1000);
		});
		$(document).on('click', '.nb-toc-title', function (event) {
			let a = $(this).closest('#nb-toc-article');
			a.toggleClass('active');
		});
		window.addEventListener('scroll', function () {
			let $toc = document.getElementById('nb-toc-article');
			let rec = $toc.parentElement.getBoundingClientRect();
			let top = rec.top;
			let height = rec.height;
			let limit = content.getBoundingClientRect().bottom;
			if (top <= 0 && limit >= 0) {
				$toc.classList.remove('no-fixed');
				$toc.classList.add('fixed');
			} else {
				// if ($toc.classList.contains("fixed")) {
				//   $toc.classList.remove("active");
				// }
				$toc.classList.remove('fixed');
				$toc.classList.add('no-fixed');
			}
		});
		const headings = content.querySelectorAll('h2, h3, h4, h5, h6');
		if (headings.length) {
			function getTOCItem(id, el) {
				id = 'toc-' + id;
				el.setAttribute('id', id);
				let $li = document.createElement('li');
				let $a = document.createElement('a');
				$a.className = 'nb-toc-item-link';
				$a.href = '#' + id;
				$a.title = el.textContent.trim().replace(/^[1-9]\./, '');
				$a.textContent = $a.title;
				$li.appendChild($a);
				return $li;
			}
			function buildTOC(items, currentLevel = 2) {
				let $ol = document.createElement('ol');
				$ol.className = 'nb-toc-list';
				let time = new Date().getTime();
				while (items.length) {
					const currentItem = items[0];
					const currentLevelNumber = parseInt(currentItem.tagName[1]);
					if (currentLevelNumber === currentLevel) {
						let $li = getTOCItem(time + items.length, currentItem);
						items.shift();
						const subItems = buildTOC(items, currentLevel + 1);
						if (subItems.childNodes.length) {
							$li.appendChild(subItems);
						}
						$ol.appendChild($li);
					} else if (currentLevelNumber > currentLevel) {
						break;
					} else {
						return $ol;
					}
				}
				return $ol;
			}
			let $toc = document.getElementById('nb-toc-article');
			let $toc_ol = buildTOC(Array.from(headings));
			$toc.appendChild($toc_ol);
		}
	}
});
//================================ End TOC article =================================
//================================ Loadmore Author =================================
$('.t4s-loadmore-btn-author').on('click', function () {
	let limit = $(this).data('limit');
	let $wrap = $(this).closest('[data-ntajax-options]');
	let allItems = $wrap.find('article.t4s-post-item');
	// console.log(allItems.length);
	let hiddenItems = $wrap.find('article.t4s-post-item.t4s-d-none');
	// console.log(hiddenItems.length);
	for (let i = 0; i < limit && i < hiddenItems.length; i++) {
		hiddenItems[i].classList.remove('t4s-d-none');
	}
	hiddenItems = $wrap.find('article.t4s-post-item.t4s-d-none');
	let displayedItems = allItems.length - hiddenItems.length;
	let percentageDisplayed = (displayedItems / allItems.length) * 100;
	$wrap.find('[data-current-bar]').text(displayedItems);
	$wrap.find('.t4s-lm-bar--current').css('width', percentageDisplayed + '%');
	if (hiddenItems.length === 0) {
		$(this).hide();
	}
});
//================================ End Loadmore Author =================================
//================================ Variant switcher =====================================
function checkShowVariantPopup(data) {
	for (let j = 0; j < Shopify.cart.items.length; j++) {
		let item = Shopify.cart.items[j];
		if (!data.quantity || data.quantity > 1 || item.id != data.id || getCookie('popupswitchvariant.' + data.id)) {
			continue;
		}
		let url = data.url.split('?')[0];
		MyAPI.section.getSection(url + '?section_id=popupswitchvariant', async (res) => {
			let $popup = $(res);
			$popup.find(`.popup-variant-item:not([data-variant-id="${data.id}"])`).remove();
			if ($popup.find(`.popup-variant-item`).length) {
				// MyAPI.cart.close();
				await sleep(0.5);
				let popupVariant = $('body').find(`.popup-variant-item[data-variant-id="${data.id}"]`);
				if (popupVariant.length == 0) {
					$('body').append($popup[0]);
				} else {
					popupVariant.addClass('active');
				}
			}
		});
	}
}
$(document).ready(function () {
	$(document).on('click', '.popup-variant-close', function (e) {
		$(this).closest('.popup-variant-switch').remove();
	});
	$(document).on('click', '[data-switch-variant]', function (e) {
		let $this = $(this);
		let key = $this.data('key');
		let id = $this.data('switch');
		$this.addClass('is--loading');
		$this.find('.t4s-loading__spinner').removeAttr('hidden');
		$this.find('.t4s-loading__spinner svg').removeAttr('hidden');
		$this.closest('[data-cart-item]').addClass('is--update');
		MyAPI.cart.isLoading(true);
		let properties = {};
		if ($this.data('property')) {
			properties[$this.data('property')] = 'true';
		}
		MyAPI.cart.deleteItem({ id: key, action: 'notier' }, async (res) => {
			await sleep(1);
			MyAPI.cart.addItem(
				{
					id: id,
					selling_plan: $this.data('selling-plan'),
					properties: properties,
				},
				async (res) => {
					if ($this.closest('[data-variant-id]').length) {
						setCookie('popupswitchvariant.' + $this.closest('[data-variant-id]').data('variant-id'), true, 7);
					}
					if ($('.popup-variant-close').length) {
						MyAPI.cart.open();
						$('.popup-variant-close').trigger('click');
					}
					$this.removeClass('is--loading');
					$this.find('.t4s-loading__spinner').attr('hidden', true);
					$this.find('.t4s-loading__spinner svg').attr('hidden', true);
					$this.closest('[data-cart-item]').removeClass('is--update');
					MyAPI.cart.isLoading(true);
				},
			);
		});
	});
});
//================================ End Variant switcher =====================================
// ================================ Fancybox ===============================================
$(document).ready(function () {
	if ($('[data-fancybox]').length) {
		addCSS('/cdn/shop/t/83/assets/fancybox.css');
		addScript('/cdn/shop/t/83/assets/fancybox.umd.js').then(() => {
			Fancybox.bind('[data-fancybox]', {});
		});
	}
});
// ================================ End Fancybox ===============================================
//================================ Frequently Bought Together =====================================
$(document).ready(function () {
	let $fbt = $('.PDP-newOddit-Block-FBT');
	$(document).on('change', '.FBT-product-checkbox', function (e) {
		$fbt.find(`.FBT-product-item[data-vid="${this.value}"]`).toggle(this.checked);
		let products = $fbt.find('.FBT-product-checkbox:checked');
		let price = 0;
		let ids = [];
		for (let i = 0; i < products.length; i++) {
			let product = products[i];
			price += $(product).data('price');
			ids.push(product.value);
			if (i + 1 == products.length) {
				$fbt.find(`.FBT-product-item`).removeClass('last-item');
				$fbt.find(`.FBT-product-item[data-vid="${product.value}"]`).addClass('last-item');
			}
		}
		$fbt.find('.FBT-total-price').html(formatCC(price));
		let btnATC = $fbt.find('[data-add-to-cart]');
		btnATC.attr('data-id', ids.join('|'));
		btnATC.data('id', ids.join('|'));
		btnATC.prop('disabled', products.length == 0);
	});
});
//================================ End Frequently Bought Together =====================================
//================================ tamix tooltips =================================
function getTamixTooltipPosition(iconRect) {
	const viewportWidth = window.innerWidth;
	const viewportHeight = window.innerHeight;
	const margin = 16;
	const tooltipWidth = Math.min(360, 0.7 * viewportWidth);
	const tooltipHeight = 200;
	let left = 0;
	left += 'px';
	let right = tooltipWidth;
	let transY = 0;
	if (viewportWidth - iconRect.right < margin + tooltipWidth) {
		left = 'auto';
		right = viewportWidth - iconRect.right - margin;
	}
	let arr_left = 4;
	if (tooltipWidth - right > 8) {
		arr_left = tooltipWidth - right - 12;
	}
	arr_left += 'px';
	let arr_top = 'auto';
	let arr_bottom = '-4px';
	let arr_tranZ = ' 0';
	if (iconRect.top < tooltipHeight) {
		transY = ' calc( 100% + 32px )';
		arr_tranZ = ' 180deg';
		arr_top = '-4px';
		arr_bottom = 'auto';
	}
	return {
		transY,
		left,
		right,
		arr_left,
		arr_top,
		arr_bottom,
		arr_tranZ,
	};
}
function setupTamixTooltipPosition(tooltip) {
	const icon = tooltip.querySelector('.tooltips-icon');
	const content = tooltip.querySelector('.tooltips-content');
	if (!icon || !content) return;
	if (tooltip.dataset.tamixTooltipInit === 'true') return;
	tooltip.dataset.tamixTooltipInit = 'true';
	icon.addEventListener('mouseenter', () => {
		const iconRect = icon.getBoundingClientRect();
		const pos = getTamixTooltipPosition(iconRect);
		// console.log(pos);
		content.style.position = 'absolute';
		content.style.left = `${pos.left}`;
		content.style.right = `-${pos.right}px`;
		content.style.transform = `translate(0, ${pos.transY})`;
		content.style.setProperty('--tamix-tooltip-arrow-left', `${pos.arr_left}`);
		content.style.setProperty('--tamix-tooltip-arrow-top', `${pos.arr_top}`);
		content.style.setProperty('--tamix-tooltip-arrow-bottom', `${pos.arr_bottom}`);
		content.style.setProperty('--tamix-tooltip-arrow-tranz', `${pos.arr_tranZ}`);
	});
}
function initTamixTooltipsWithObserver() {
	document.querySelectorAll('.tamix-tooltips').forEach(setupTamixTooltipPosition);
	const observer = new MutationObserver((mutations) => {
		mutations.forEach((mutation) => {
			mutation.addedNodes.forEach((node) => {
				if (!(node instanceof Element)) return;
				if (node.matches('.tamix-tooltips')) {
					setupTamixTooltipPosition(node);
				}
				if (node.querySelectorAll) {
					node.querySelectorAll('.tamix-tooltips').forEach(setupTamixTooltipPosition);
				}
			});
		});
	});
	observer.observe(document.body, {
		childList: true,
		subtree: true,
	});
}
document.addEventListener('DOMContentLoaded', initTamixTooltipsWithObserver);
//================================ tamix tooltips =================================
//================================ Popup Ingredient =====================================
$(document).ready(function () {
	$(document).on('click', '.tamix-popup-ingredient', function (e) {
		let $popup = $($(this).data('target'));
		$popup.find(`[data-ingredient-title]`).html($(this).data('title'));
		let $content = $popup.find(`[data-ingredient-content]`);
		let $wrap = $popup.find('.t4s-drawer__wrap');
		// $content.closest('.t4s-drawer__wrap').addClass('is--loading');
		$content.html('');
		T4SThemeSP.Drawer.opend($popup);
		addCSS('/cdn/shop/t/170/assets/supplement-facts.css?v=133289130345025828681785483079');
		MyAPI.section.getSection($(this).data('url') + '?section_id=product-ingredient', async (res) => {
			let $data = $(res);
			$content.html($data.find(`[data-ingredient-html`).html());
			// $content.html($data.find(`[data-ingredient-image-${screen.width >= 630 ? 'pc' : 'mb'}]`).html());
			// await sleep(0.5);
			// $wrap.removeClass('is--loading');
		});
	});
});
//================================ End Popup Ingredient =====================================
//================================ NuBest Gifts =====================================
async function checkNBGift(action = null) {
	let widget = '#nb-gift-widget';
	// if (typeof klaviyo != 'undefined') {
	// 	const identify = await klaviyo.isIdentified();
	// 	// console.log('checkNBGift identify', identify);
	// 	if (identify) {
	// 		const _kx = JSON.parse(atob(getCookie('__kla_id'))).$exchange_id;
	// 		if (!_kx) return;
	// 		const segment_id = 'XgTJyu';
	// 		const _key = `__kla_${segment_id}_${_kx}`;
	// 		// console.log('checkNBGift action', action);
	// 		if (action == 'submit_form') setCookie(_key, '', 3);
	// 		let _seg = getCookie(_key);
	// 		// console.log('checkNBGift _seg', _seg);
	// 		if (!_seg) {
	// 			const segment = await fetch('/tools/crm/klaviyo/segments', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ _kx, segment_id }) }).then((r) => r.json());
	// 			// console.log('checkNBGift segment', segment);
	// 			_seg = Object.keys(segment).length > 0 ? 'true' : 'false';
	// 			setCookie(_key, _seg, 3);
	// 		}
	// 		if (_seg == 'false') {
	// 			$(widget).removeClass('show');
	// 			return;
	// 		}
	// 	}
	// }
	let $g = $('#nb-gifts');
	if (!$g.length) return;
	let data;
	await MyAPI.section.getSection(location.pathname + '?section_id=nb_gifts', (res) => {
		data = res;
	});
	if (!data) return;
	let $d = $(data);
	let iframe = '#nb-gift-iframe';
	let popup = '#nb-gift-popup';
	$g.find(iframe).replaceWith($d.find(iframe).toggleClass('show', $g.find(iframe).hasClass('show')));
	$g.find(popup)
		.html($d.find(popup).html())
		.promise()
		.done(function () {
			let pre = queryParam('nb_rewards') || getCookie('nb_rewards');
			if (pre) {
				const from = $g.data('from');
				let dayLeft = 7;
				if (from) {
					dayLeft = Math.ceil((new Date(from) - new Date()) / 86400000) + 1;
				}
				setCookie('nb_rewards', pre, dayLeft);
				$(widget).addClass('show');
				if ($(popup).hasClass('page_show')) {
					$(popup).addClass('show');
				}
			} else if ($(widget).hasClass('pre')) {
				return;
			}
			$(widget).addClass('show');
			let show = $d.find('#nbgp-products').length > 0;
			if (getCookie('nb_gifts') === 'hidden') {
				show = false;
			}
			if (show) {
				T4SThemeSP.initCarousel();
			}
			$g.find(popup).toggleClass('show', show);
		});
}
$(document).ready(function () {
	!(function () {
		const e = () => {
				let e = 0,
					t = setInterval(async () => {
						(await klaviyo.isIdentified()) ? (checkNBGift('submit_form'), clearInterval(t)) : ++e > 20 && clearInterval(t);
					}, 500);
			},
			t = () => {
				if (!window.KlaviyoSubscribe || !window.KlaviyoSubscribe.log) return setTimeout(t, 50);
				const o = KlaviyoSubscribe.log;
				KlaviyoSubscribe.log = function (...t) {
					return ('Waiting for DOM to process queue.' === t[0] && checkNBGift(), '$source' === t[0] && e(), o.apply(this, t));
				};
			};
		t();
	})();
	if (window.location.pathname.includes('/products/gift-')) {
		window.location.replace(window.location.href.replace('/gift-', '/'));
	}
	$(document).on('click', '#nb-gift-widget', function (e) {
		$('#nb-gift-iframe').toggleClass('show');
	});
	$(document).on('click', '[data-nb-gift-close]', function (e) {
		setCookie('nb_gifts', 'hidden', $(this).hasClass('popup-hidden') ? 2 : 0);
		$(this).closest('.show').removeClass('show');
	});
	$(document).on('click', '.nbgio-products-more', function (e) {
		$('#nb-gift-iframe .nbgio-products .hide').removeClass('hide');
		$(this).remove();
	});
	$(document).on('click', '[data-nb-gift-popup]', function (e) {
		$('#nb-gift-popup').addClass('show');
		T4SThemeSP.initCarousel();
	});
	$(document).on('change', '.nbgiop-select', function (e) {
		const $this = $(this);
		$this.closest('#nb-gift-iframe').addClass('is--loading');

		let updates = {};
		updates[$this.data('id')] = 1;
		if ($this.val()) {
			updates[$this.val()] = 0;
			MyAPI.cart.updateCart({ updates }, (res) => {
				const index = res.items.findIndex((it) => $this.data('id') == it.variant_id);
				MyAPI.cart.updateItem({ line: index + 1, properties: $this.data('properties') });
			});
		} else {
			MyAPI.cart.addItem($this.data(), () => {
				MyAPI.cart.open();
			});
		}
	});
});
//================================ End NuBest Gifts =====================================
//================================ tamix-popup-parent =====================================
function openTamixPopup() {
	document.querySelectorAll('.tamix-popup-parent-section .tamix-popup-background').forEach((bg) => bg.classList.add('active'));
	setTimeout(() => {
		document.querySelectorAll('.tamix-popup-parent-section .tamix-popup-background .tamix-popup-parent').forEach((el) => {
			el.style.transform = 'translateY(0px)';
		});
		TamixPopup_addSwipeToClose('.tamix-popup-parent-section', closeTamixPopup);
	}, 200);
	setTimeout(() => {
		document.querySelectorAll('.tamix-popup-parent-section .tamix-popup-background .tamix-popup-parent').forEach((parent) => parent.classList.add('transition-0'));
	}, 500);
	document.querySelectorAll('.tamix-popup-parent-section .tamix-popup-background').forEach((bg) => {
		bg.addEventListener('click', function (event) {
			if (event.target === bg) {
				closeTamixPopup();
			}
		});
	});
}
function closeTamixPopup() {
	document.querySelectorAll('.tamix-popup-parent-section .tamix-popup-background .tamix-popup-parent').forEach((el) => el.classList.remove('transition-0'));
	setTimeout(() => {
		document.querySelectorAll('.tamix-popup-parent-section .tamix-popup-background .tamix-popup-parent').forEach((el) => {
			el.style.transform = 'translateY(100%)';
		});
	}, 100);
	setTimeout(() => {
		document.querySelectorAll('.tamix-popup-parent-section .tamix-popup-parent .tamix-popup-parent-body  .tamix-popup-parent-content').forEach((el) => (el.innerHTML = ''));
		document.querySelectorAll('.tamix-popup-parent-section .tamix-popup-background').forEach((el) => el.classList.remove('active'));
		TamixPopup_removeSwipeToClose('.tamix-popup-parent-section');
	}, 600);
}
let TamixPopup_startY = 0;
let TamixPopup_lastY = 0;
let TamixPopup_originY = 0;
let TamixPopup_isSwiping = false;
let TamixPopup_popupContent = null;
let TamixPopup_currentTranslateY = 0;
let TamixPopup_hasStarted = false;
function TamixPopup_addSwipeToClose(popupSelector, onClose) {
	const TamixPopup_popup = document.querySelector(popupSelector);
	if (!TamixPopup_popup) return;
	TamixPopup_popupContent = TamixPopup_popup.querySelector('.tamix-popup-parent');
	if (!TamixPopup_popupContent) return;
	function TamixPopup_getY(e) {
		return e.touches ? e.touches[0].clientY : e.clientY;
	}
	function TamixPopup_onStart(e) {
		const y = TamixPopup_getY(e);
		TamixPopup_startY = y;
		TamixPopup_originY = y;
		TamixPopup_lastY = y;
		TamixPopup_currentTranslateY = 0;
		TamixPopup_isSwiping = true;
		TamixPopup_hasStarted = true;
	}
	function TamixPopup_onMove(e) {
		e.preventDefault();
		if (!TamixPopup_isSwiping || !TamixPopup_hasStarted) return;
		const TamixPopup_currentY = TamixPopup_getY(e);
		const TamixPopup_delta = TamixPopup_currentY - TamixPopup_lastY;
		//console.log("TamixPopup_delta Move: " + TamixPopup_delta );
		TamixPopup_lastY = TamixPopup_currentY;
		TamixPopup_currentTranslateY += TamixPopup_delta;
		if (TamixPopup_currentTranslateY < 0) TamixPopup_currentTranslateY = 0;
		TamixPopup_popupContent.style.transform = `translateY(${TamixPopup_currentTranslateY}px)`;
		if (Math.abs(TamixPopup_currentY - TamixPopup_startY) >= 20 && TamixPopup_delta > 0) {
			TamixPopup_startY = TamixPopup_currentY;
		}
	}
	function TamixPopup_onEnd(e) {
		if (!TamixPopup_isSwiping) return;
		const TamixPopup_delta = TamixPopup_lastY - TamixPopup_startY;
		const TamixPopup_currentPosition = TamixPopup_lastY - TamixPopup_originY;
		// console.log("TamixPopup_delta End: " + TamixPopup_delta );
		//console.log("TamixPopup_currentPosition: " + TamixPopup_currentPosition );
		if (TamixPopup_delta >= 0 && TamixPopup_currentPosition > 120) {
			onClose();
		} else {
			TamixPopup_popupContent.style.transition = 'transform 0.3s ease';
			TamixPopup_popupContent.style.transform = 'translateY(0)';
			TamixPopup_currentTranslateY = 0;
			setTimeout(() => {
				if (TamixPopup_popupContent) {
					TamixPopup_popupContent.style.transition = '';
				}
			}, 300);
		}
		TamixPopup_isSwiping = false;
		TamixPopup_hasStarted = false;
	}
	window.addEventListener('touchstart', TamixPopup_onStart);
	window.addEventListener('touchmove', TamixPopup_onMove, { passive: false });
	window.addEventListener('touchend', TamixPopup_onEnd);
	window.addEventListener('mousedown', TamixPopup_onStart);
	window.addEventListener('mousemove', TamixPopup_onMove);
	window.addEventListener('mouseup', TamixPopup_onEnd);
	TamixPopup_popup._swipeHandlers = {
		onStart: TamixPopup_onStart,
		onMove: TamixPopup_onMove,
		onEnd: TamixPopup_onEnd,
	};
}
function TamixPopup_removeSwipeToClose(popupSelector) {
	const TamixPopup_popup = document.querySelector(popupSelector);
	if (!TamixPopup_popup || !TamixPopup_popup._swipeHandlers || !TamixPopup_popupContent) return;
	const { onStart: TamixPopup_onStart, onMove: TamixPopup_onMove, onEnd: TamixPopup_onEnd } = TamixPopup_popup._swipeHandlers;
	window.removeEventListener('touchstart', TamixPopup_onStart);
	window.removeEventListener('touchmove', TamixPopup_onMove);
	window.removeEventListener('touchend', TamixPopup_onEnd);
	window.removeEventListener('mousedown', TamixPopup_onStart);
	window.removeEventListener('mousemove', TamixPopup_onMove);
	window.removeEventListener('mouseup', TamixPopup_onEnd);
	delete TamixPopup_popup._swipeHandlers;
}
function checkTamixPopup(name, item) {
	if (name && item.id) {
		const id = 'tamix-popup-parent-section';
		const sid = '#shopify-section-' + id;
		const url = item.url.split('?')[0];
		let s = name;
		let c = $(sid).length;
		if (!c) s += ',' + id;
		MyAPI.section.getSections(url + '?sections=' + s, (res) => {
			let d = $(res[name]);
			if (d.html().trim()) {
				if (!c) $('body').append(res[id]);
				$(sid).find('.tamix-popup-parent-content').append(d);
				setTimeout(() => {
					openTamixPopup();
				}, 2000);
			}
		});
	}
}
$(document).ready(function () {
	$(document).on('click', '.btn-addtocart-product-pairing', function (event) {
		// console.log('btn-addtocart-product-pairing');
		$(this).addClass('is--loading');
		$(this).prop('disabled', true);
		$(this).find('.t4s-loading__spinner, .t4s-loading__spinner svg').removeAttr('hidden');
		MyAPI.cart.addItem(paramATC(this), (res) => {
			$(this).text('Added');
			getRecommendationsCart(res.product_id ? res.product_id : res.items ? res.items[0].product_id : null);
			setTimeout(() => {
				closeTamixPopup();
			}, 1000);
		});
	});
});
//================================ End tamix-popup-parent =====================================
//======================minicart icon scroll down ==========
function handleScrollEffect(scrollEl, miniCart) {
	const targetElForClass = miniCart.querySelector('.t4s-drawer__main') || miniCart;
	function updateScrollClasses() {
		const scrollTop = scrollEl.scrollTop;
		const scrollHeight = scrollEl.scrollHeight;
		const offsetHeight = scrollEl.offsetHeight;
		targetElForClass.classList.remove('scroll-top', 'scroll-bottom');
		if (scrollHeight > offsetHeight) {
			if (scrollTop < 90) {
				targetElForClass.classList.add('scroll-top');
			} else if (scrollTop + offsetHeight >= scrollHeight - 1) {
				targetElForClass.classList.add('scroll-bottom');
			}
		}
	}
	let debounceTimer;
	scrollEl.removeEventListener('scroll', scrollEl._scrollHandler || (() => {}));
	scrollEl._scrollHandler = () => {
		clearTimeout(debounceTimer);
		debounceTimer = setTimeout(updateScrollClasses, 20);
	};
	scrollEl.addEventListener('scroll', scrollEl._scrollHandler);
	updateScrollClasses();
	const itemsContainer = miniCart.querySelector('.t4s-drawer__scroll.t4s-current-scrollbar .t4s-mini_cart__items');
	if (itemsContainer) {
		if (itemsContainer._itemObserver) {
			itemsContainer._itemObserver.disconnect();
		}
		const itemObserver = new MutationObserver(() => {
			updateScrollClasses();
		});
		itemObserver.observe(itemsContainer, {
			childList: true,
			subtree: false,
		});
		itemsContainer._itemObserver = itemObserver;
	}
}
function waitForScrollableElement(maxWait = 5000) {
	const miniCart = document.getElementById('t4s-mini_cart');
	if (!miniCart) return;
	let elapsed = 0;
	const interval = 100;
	const timer = setInterval(() => {
		const scrollEl = miniCart.querySelector('.t4s-drawer__scroll.t4s-current-scrollbar');
		if (scrollEl && scrollEl.scrollHeight > scrollEl.clientHeight) {
			clearInterval(timer);
			if (!scrollEl.classList.contains('--scroll-initialized')) {
				scrollEl.classList.add('--scroll-initialized');
				handleScrollEffect(scrollEl, miniCart);
			}
		}
		elapsed += interval;
		if (elapsed >= maxWait) {
			clearInterval(timer);
		}
	}, interval);
}
function observeMiniCartToggle() {
	const miniCart = document.getElementById('t4s-mini_cart');
	if (!miniCart) return;
	const observer = new MutationObserver((mutations) => {
		for (const mutation of mutations) {
			if (mutation.type === 'attributes' && mutation.attributeName === 'aria-hidden') {
				const isVisible = miniCart.getAttribute('aria-hidden') === 'false';
				if (isVisible) {
					waitForScrollableElement();
				} else {
					const scrollEl = miniCart.querySelector('.t4s-drawer__scroll.t4s-current-scrollbar');
					if (scrollEl) {
						scrollEl.classList.remove('--scroll-initialized');
						if (scrollEl._itemObserver && typeof scrollEl._itemObserver.disconnect === 'function') {
							scrollEl._itemObserver.disconnect();
						}
					}
				}
			}
		}
	});
	observer.observe(miniCart, {
		attributes: true,
		attributeFilter: ['aria-hidden'],
	});
}
document.addEventListener('DOMContentLoaded', () => {
	observeMiniCartToggle();
});
async function ipGeoLocation() {
	let geo = getCookie('ipgeolocation');
	if (geo) {
		try {
			return JSON.parse(geo);
		} catch {}
	} else {
		try {
			const res = await fetch('https://api.ipgeolocation.io/v2/ipgeo?apiKey=c4ddfac0f1f0411a8682871b7b707792');
			const data = await res.json();
			setCookie('ipgeolocation', JSON.stringify(data), 7);
			return data;
		} catch (error) {}
	}
}
document.addEventListener('DOMContentLoaded', async (event) => {
	let prop65 = $('[data-prop65-warning]');
	if (prop65.length) {
		const data = await ipGeoLocation();
		if (data && data.location) {
			const state_code = data.location.state_code;
			if (state_code == 'US-CA') {
				MyAPI.section.getSection('prop65-warning', (res) => {
					prop65.html(res);
				});
			}
		}
	}
});
document.addEventListener('DOMContentLoaded', (event) => {
	$(document).on('click', '.tamix-mini-buybox .sns-item', function (event) {
		let contain = $(this).closest('.tamix-mini-buybox');
		contain.find('.sns-item').removeClass('active');
		$(this).addClass('active');
		let variant = contain.find('.variant-item.active');
		contain.find('[name="id"]').val(variant.data('id'));
		contain.find('[name="selling_plan"]').val($(this).hasClass('sns-item-sub') ? variant.data('spid') : '');
	});
	$(document).on('click', '.tamix-mini-buybox .variant-item', function (event) {
		let contain = $(this).closest('.tamix-mini-buybox');
		contain.find('.variant-item').removeClass('active');
		$(this).addClass('active');
		contain.find('[name="id"]').val($(this).data('id'));
		contain.find('[name="selling_plan"]').val(contain.find('.sns-item-sub.active').length ? $(this).data('spid') : '');
		let image = contain.find('.tamix-mini-buybox-image img').prop('outerHTML');
		let image_replace = image.replaceAll(image.split('data-srcset="')[1].split('?')[0], `//www.nubest.com/cdn/shop/${$(this).data('image')}`);
		contain.find('.tamix-mini-buybox-image img').replaceWith(image_replace);
		contain.find('[buybox-price_old]').text($(this).data('price_old') > $(this).data('price') ? formatCC($(this).data('price_old')) : '');
		contain.find('[buybox-price]').text(formatCC($(this).data('price')));
		contain.find('[buybox-label]').text($(this).data('label')).css('background', $(this).data('label_color'));
		contain.find('[buybox-discount_text]').text($(this).data('discount_text'));
		contain.find('[buybox-discount_text_2]').text($(this).data('discount_text_2') ? `(${$(this).data('discount_text_2')})` : '');
	});
});
(function () {
	const configEl = document.getElementById('BundleStoreConfig');
	const BundleConfig = configEl ? JSON.parse(configEl.textContent) : [];
	async function autoAddBundles() {
		if (!BundleConfig.length) return;
		if (document.querySelector('.Bundle2025-product-item')) return;
		const KEY = 'Bundle2025';
		const state = JSON.parse(localStorage.getItem(KEY) || '{}');
		if (!Object.keys(state).length) return;
		await MyAPI.cart.getCart();
		for (const config of BundleConfig) {
			const bundleState = state[config.handle];
			if (!bundleState) continue;
			let valid = true;
			for (const stepKey in config.steps) {
				const stepCfg = config.steps[stepKey];
				const allowed = new Set((stepCfg.items || []).map(Number));
				let stepItems = (bundleState[stepKey] || [])
					.filter((i) => i && allowed.has(+i.id))
					.map((i) => ({
						...i,
						id: +i.id,
						quantity: Math.max(1, +i.quantity || 1),
					}));
				const mergedMap = new Map();
				for (const item of stepItems) {
					const found = mergedMap.get(item.id);
					if (found) {
						found.quantity += item.quantity;
					} else {
						mergedMap.set(item.id, { ...item });
					}
				}
				stepItems = [...mergedMap.values()];
				const min = +stepCfg.min || 0;
				const max = +stepCfg.max || 0;
				if (max && stepItems.length > max) {
					stepItems = stepItems.slice(0, max);
				}
				bundleState[stepKey] = stepItems;
				if (stepItems.length < min) {
					valid = false;
					break;
				}
			}
			for (const key in bundleState) {
				if (!config.steps[key]) delete bundleState[key];
			}
			for (const key in config.steps) {
				if (!bundleState[key]) bundleState[key] = [];
			}
			state[config.handle] = bundleState;
			if (!valid) continue;
			const items = Object.values(bundleState)
				.flat()
				.filter((i) => i.quantity > 0);
			if (!items.length) continue;
			const property = {
				key: Date.now(),
				id: config.id,
				bundle: config.name,
				box: Shopify.cart.items.filter((line) => (line.properties && line.properties._nubest_bundle_id) || (line.properties && line.properties._nubest_bundle)).length + 1,
			};
			const payload = items.map(({ id, quantity, name, sku, handle, price }) => ({
				id,
				quantity,
				properties: {
					_nubest_bundle: JSON.stringify({ ...property, name, sku, handle, quantity, price }),
					_my_boost_type: 'Bundle Builder',
				},
			}));
			await new Promise((resolve) => {
				// console.log('Add Bundle', payload);
				MyAPI.cart.addItem({ items: payload }, async () => {
					delete state[config.handle];
					await MyAPI.cart.getCart();
					resolve();
				});
			});
		}
		localStorage.setItem(KEY, JSON.stringify(state));
	}
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', autoAddBundles);
	} else {
		autoAddBundles();
	}
})();
// Custom button checkout savedby
window.addEventListener(
	'SavedBy:ready',
	() => {
		// console.log("SavedBy ready");
		SavedBy.onCheckout(function (e) {
			// console.log('SavedBy onCheckout');
			$('savedby-checkout-plus button[name="checkout"]').html('Proceeding to Checkout...');
		});
	},
	{ once: true },
);
// Snippets tamix-remove-iherb-param
(function () {
	const TARGET_DOMAIN = 'iherb.com';
	const PARAM_TO_REMOVE = 'rcode';
	const VALUE_TO_REMOVE = 'LUI5678';
	const SOURCE_KEYWORDS = ['facebook', 'instagram', 'google', 'tiktok', 'youtube', 'taboola', 'bing'];
	const currentUrlParams = new URLSearchParams(window.location.search);
	const allParamValues = Array.from(currentUrlParams.values()).join(' ').toLowerCase();
	const isTargetSource = SOURCE_KEYWORDS.some((keyword) => allParamValues.includes(keyword));
	if (!isTargetSource) return;
	function cleanIHerbLinks() {
		const selector = `a[href*="${TARGET_DOMAIN}"][href*="${PARAM_TO_REMOVE}=${VALUE_TO_REMOVE}"]`;
		const links = document.querySelectorAll(selector);
		links.forEach((link) => {
			try {
				const url = new URL(link.href);
				if (url.hostname.includes(TARGET_DOMAIN)) {
					if (url.searchParams.get(PARAM_TO_REMOVE) === VALUE_TO_REMOVE) {
						url.searchParams.delete(PARAM_TO_REMOVE);
						link.href = url.toString();
					}
				}
			} catch (e) {
				// ignore invalid URLs
			}
		});
	}
	if (window.requestIdleCallback) {
		window.requestIdleCallback(cleanIHerbLinks);
	} else {
		setTimeout(cleanIHerbLinks, 500);
	}
	const observer = new MutationObserver((mutations) => {
		if (mutations.some((m) => m.addedNodes.length > 0)) {
			cleanIHerbLinks();
		}
	});
	observer.observe(document.body, { childList: true, subtree: true });
})();
// HP-newOddit-Block-02-snippet
document.addEventListener('DOMContentLoaded', function () {
	var marqueeElement = document.querySelector('[x-data="marquee"]');
	if (marqueeElement && window.matchMedia('(max-width: 991px)').matches) {
		document.querySelectorAll('.HP-newOddit-Block-02-snippet img[data-src]').forEach((image) => {
			image.src = image.dataset.src;
			image.removeAttribute('data-src');
		});
		let ua = function () {
			return {
				marqueeInner: null,
				marqueeEls: null,
				marqueeSpeed: null,
				marqueePrepend: !1,
				centerOnFit: !1,
				marqueeWidth: 0,
				marqueeHeight: 0,
				init: function () {
					var e = this;
					setTimeout(function () {
						e.marqueeLogic();
					}, 100);
				},
				marqueeLogic: function () {
					var e = this;
					if (
						((this.marqueeInner = this.$el.closest('[data-marquee-inner]')),
						(this.marqueeEls = this.$el.querySelectorAll('[data-marquee-el]')),
						(this.marqueeSpeed = this.$el.getAttribute('data-marquee-speed')),
						(this.marqueePrepend = this.$el.hasAttribute('data-marquee-prepend')),
						(this.centerOnFit = this.$el.hasAttribute('data-center-fit')),
						(this.marqueeWidth = 0),
						(this.marqueeHeight = 0),
						this.marqueeEls.forEach(function (t) {
							var n = t.getBoundingClientRect().width,
								r = t.getBoundingClientRect().height;
							((n += parseInt(window.getComputedStyle(t).getPropertyValue('margin-left'))), (n += parseInt(window.getComputedStyle(t).getPropertyValue('margin-right'))), (r += parseInt(window.getComputedStyle(t).getPropertyValue('margin-top'))), (r += parseInt(window.getComputedStyle(t).getPropertyValue('margin-bottom'))), (e.marqueeWidth += n), r > e.marqueeHeight && (e.marqueeHeight = r));
						}),
						this.$el.querySelectorAll('[data-clone-marquee-el], [data-pre-clone-marquee-el]').forEach(function (e) {
							return e.remove();
						}),
						this.marqueeWidth)
					) {
						var t = this.marqueeInner.getBoundingClientRect().width - parseFloat(window.getComputedStyle(this.marqueeInner).paddingLeft) - parseFloat(window.getComputedStyle(this.marqueeInner).paddingRight);
						if (((this.$el.style.width = ''.concat(this.marqueeWidth, 'px')), (this.marqueeInner.style.height = ''.concat(this.marqueeHeight, 'px')), this.marqueeWidth < t && this.centerOnFit)) return (this.$el.removeAttribute('style'), this.marqueeInner.classList.add('justify-center', 'container'), this.$el.classList.remove('marquee', 'absolute'), this.$el.classList.add('static', 'w-full', 'justify-center'), void (this.marqueePrepend = !1));
						(this.$el.style.setProperty('--marquee-speed', this.marqueeSpeed), this.$el.classList.add('marquee', 'absolute'), this.$el.classList.remove('static', 'w-full', 'justify-between'), this.marqueeInner.classList.remove('justify-center', 'container'));
						var n = Math.ceil(window.innerWidth / this.marqueeWidth);
						(this.marqueePrepend && ((this.$el.style.width = 'max-content'), (this.$el.style.transform = this.$el.style.transform || 'translateX(-50%)'), (this.$el.style.left = '50%'), (n /= 2) % 2 != 0 && n++), this.calculateDuplicates(this.marqueeEls, n));
					}
				},
				calculateDuplicates: function (e, t) {
					for (var n = this, r = 0; r < t; r++)
						e.forEach(function (t) {
							var r = t.cloneNode(!0);
							if ((r.removeAttribute('data-marquee-el'), r.setAttribute('data-clone-marquee-el', !0), n.marqueePrepend)) {
								var i = t.cloneNode(!0);
								(i.removeAttribute('data-marquee-el'), i.setAttribute('data-pre-clone-marquee-el', !0), e[0].before(i));
							}
							n.$el.appendChild(r);
						});
				},
			};
		};
		let marqueeInstance = ua();
		marqueeInstance.$el = marqueeElement;
		marqueeInstance.init();
	}
});
(function () {
	var r = 'data-atomato-js-loaded';
	function d() {
		var t = document.getElementById('atomato-app');
		if (!(!t || t.getAttribute(r))) {
			var n = t.getAttribute('data-js-href');
			if (n) {
				t.setAttribute(r, 'true');
				var o = t.getAttribute('data-css-href');
				if (o && !document.querySelector('link[data-atomato-css-preload]')) {
					var e = document.createElement('link');
					((e.rel = 'preload'), (e.as = 'style'), (e.href = o), e.setAttribute('data-atomato-css-preload', 'true'), document.head.appendChild(e));
				}
				var a = document.createElement('script');
				((a.src = n), (a.async = !0), document.head.appendChild(a));
			}
		}
	}
	document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', d) : d();
})();
